import React, { useState, useEffect } from 'react';
import api, { finanzasApi, gastosApi, workSessionApi } from '../services/api';
// import finanzasUnificadasService from '../services/finanzasUnificadasService';
import SueldosConfigTable from './SueldosConfigTable';
import PagosEmpleadosOrganizados from './PagosEmpleadosOrganizados';

interface FinanzasCompletoProps {
  user: any;
}

const FinanzasCompleto: React.FC<FinanzasCompletoProps> = ({ user }) => {
  const [activeTab, setActiveTab] = useState<'resumen' | 'ingresos' | 'egresos' | 'balance' | 'configuracion' | 'personal' | 'atraso-clientes' | 'comisiones'>('resumen');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [mostrarFormGasto, setMostrarFormGasto] = useState(false);
  const [nuevoGasto, setNuevoGasto] = useState({
    descripcion: '',
    monto: '',
    categoria: 'operativo',
    fecha: new Date().toISOString().split('T')[0],
    explicacion: ''
  });
  
  // Estados para datos
  const [usuarios, setUsuarios] = useState([]);
  const [ingresos, setIngresos] = useState({
    auditoriasPorCobrar: [],
    auditoriasCobradasMes: [],
    clientesConDeuda: [], // Nueva estructura con períodos por mes
    totalPorCobrar: 0,
    totalCobradoMes: 0
  });
  
  const [egresos, setEgresos] = useState({
    sueldosPendientes: [],
    sueldosPagados: [],
    gastos: [],
    adelantos: [],
    totalSueldosPendientes: 0,
    totalSueldosPagados: 0,
    totalGastos: 0,
    totalAdelantos: 0,
    mesParaSueldos: new Date().getMonth() + 1, // mes actual porque mostrarSueldosMesActual = true
    anioParaSueldos: new Date().getFullYear(),
    esMesActual: true
  });
  
  const [balance, setBalance] = useState({
    ingresosTotales: 0,
    egresosTotales: 0,
    balanceNeto: 0,
    proyeccion: 0,
    saldoMesAnterior: 0,
    ingresosMes: 0,
    egresosMes: 0,
    movimientoMes: 0,
    saldoRealTotal: 0
  });

  // Estado para comisiones de ejecutivos
  const [comisiones, setComisiones] = useState<{
    lista: any[];
    resumen: { totalPendiente: number; totalPagado: number; cantidadPendientes: number; cantidadPagadas: number };
  }>({
    lista: [],
    resumen: { totalPendiente: 0, totalPagado: 0, cantidadPendientes: 0, cantidadPagadas: 0 }
  });
  const [loadingComisiones, setLoadingComisiones] = useState(false);
  const [filtroComisionEstado, setFiltroComisionEstado] = useState<'todos' | 'pendiente' | 'pagada'>('todos');

  // Filtros de período
  const [mes, setMes] = useState(new Date().getMonth() + 1);
  const [anio, setAnio] = useState(new Date().getFullYear());
  const [filtroNombre, setFiltroNombre] = useState('');
  const [mostrarSueldosMesActual, setMostrarSueldosMesActual] = useState(true);
  const [selectedEmpleado, setSelectedEmpleado] = useState('');
  const [montoAdelanto, setMontoAdelanto] = useState('');
  const [conceptoAdelanto, setConceptoAdelanto] = useState('');
  const [estadisticasReales, setEstadisticasReales] = useState({});
  const [mostrarFormIngresoManual, setMostrarFormIngresoManual] = useState<number | null>(null);
  const [ingresoManual, setIngresoManual] = useState({
    clienteId: '',
    titulo: '',
    monto: '',
    fecha: new Date().toISOString().split('T')[0]
  });
  const [mostrarFormIngresoUniversal, setMostrarFormIngresoUniversal] = useState(false);
  const [ingresoUniversal, setIngresoUniversal] = useState({
    clienteId: '',
    titulo: '',
    monto: '',
    fecha: new Date().toISOString().split('T')[0]
  });
  const [clientes, setClientes] = useState([]);
  const [vistaPorMes, setVistaPorMes] = useState(true); // true = vista por mes, false = vista por empresa

  // Estado para atraso de clientes
  const [atrasosClientes, setAtrasosClientes] = useState<any[]>([]);
  const [loadingAtrasos, setLoadingAtrasos] = useState(false);
  const [filtroAtraso, setFiltroAtraso] = useState('');

  // Estado para modal de cobro con factura
  const [showModalCobro, setShowModalCobro] = useState(false);
  const [cobroData, setCobroData] = useState<{
    clienteId: number;
    clienteNombre: string;
    mes: number;
    anio: number;
    auditorias: any[];
    totalPeriodo: number;
  } | null>(null);
  const [cobroDetalle, setCobroDetalle] = useState('');
  const [cobroFactura, setCobroFactura] = useState<File | null>(null);
  const [procesandoCobro, setProcesandoCobro] = useState(false);
  const [minDiasAtraso, setMinDiasAtraso] = useState('');
  const [clientesExpandidos, setClientesExpandidos] = useState<Set<number>>(new Set());
  const [selectedPorCliente, setSelectedPorCliente] = useState<Record<number, Set<number>>>(() => {
    try {
      const saved = localStorage.getItem('finanzas-selected-auditorias');
      if (saved) {
        const parsed = JSON.parse(saved);
        const result: Record<number, Set<number>> = {};
        for (const [key, ids] of Object.entries(parsed)) {
          if (Array.isArray(ids) && ids.length > 0) {
            result[Number(key)] = new Set(ids as number[]);
          }
        }
        return result;
      }
    } catch (e) { /* ignore */ }
    return {};
  });

  const meses = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
  ];

  // Persistir selección de checkboxes en localStorage
  useEffect(() => {
    const toSave: Record<number, number[]> = {};
    for (const [key, ids] of Object.entries(selectedPorCliente)) {
      if (ids.size > 0) {
        toSave[Number(key)] = Array.from(ids);
      }
    }
    localStorage.setItem('finanzas-selected-auditorias', JSON.stringify(toSave));
  }, [selectedPorCliente]);

  useEffect(() => {
    cargarDatos();
    cargarUsuarios();
    cargarClientes();
  }, [mes, anio, mostrarSueldosMesActual]);

  // Cargar comisiones cuando se abre la pestaña
  useEffect(() => {
    if (activeTab === 'comisiones') {
      cargarComisiones();
    }
  }, [activeTab, filtroComisionEstado]);

  const cargarUsuarios = async () => {
    try {
      const response = await api.get('/users');

      if (response.data && response.data.length > 0) {
        // Filtrar solo empleados (operador, supervisor, contable)
        const empleados = response.data.filter(user =>
          ['operador', 'supervisor', 'contable'].includes(user.role)
        );

        setUsuarios(empleados);
      } else {
        // Fallback solo si falla completamente la API
        setUsuarios([
          { id: 3, name: 'Leo Operador', role: 'operador' },
          { id: 2, name: 'Contable Usuario', role: 'contable' }
        ]);
      }
    } catch (error) {
      console.error('❌ Error cargando usuarios desde API:', error);
      // Fallback en caso de error
      setUsuarios([
        { id: 3, name: 'Leo Operador', role: 'operador' },
        { id: 2, name: 'Contable Usuario', role: 'contable' }
      ]);
    }
  };

  const cargarClientes = async () => {
    try {
      const response = await api.get('/clients');
      const clientesData = response.data?.data || response.data || [];
      setClientes(Array.isArray(clientesData) ? clientesData : []);
    } catch (error) {
      console.error('Error cargando clientes:', error);
      setClientes([]);
    }
  };

  const cargarAtrasosClientes = async () => {
    setLoadingAtrasos(true);
    try {
      let url = '/clients/listado-atraso';
      const params = new URLSearchParams();
      if (filtroAtraso) params.append('search', filtroAtraso);
      if (minDiasAtraso) params.append('minDias', minDiasAtraso);
      if (params.toString()) url += '?' + params.toString();

      const response = await api.get(url);
      setAtrasosClientes(response.data?.data || []);
      setClientesExpandidos(new Set()); // Reset expansiones al cargar
    } catch (error) {
      console.error('Error cargando atrasos de clientes:', error);
      setAtrasosClientes([]);
    } finally {
      setLoadingAtrasos(false);
    }
  };

  const toggleClienteExpandido = (clienteId: number) => {
    setClientesExpandidos(prev => {
      const newSet = new Set(prev);
      if (newSet.has(clienteId)) {
        newSet.delete(clienteId);
      } else {
        newSet.add(clienteId);
      }
      return newSet;
    });
  };

  const expandirTodosClientes = () => {
    const todosIds = atrasosClientes.map((c: any) => c.id);
    setClientesExpandidos(new Set(todosIds));
  };

  const colapsarTodosClientes = () => {
    setClientesExpandidos(new Set());
  };

  // Función para imprimir el listado de atrasos
  const imprimirListadoAtrasos = () => {
    window.print();
  };

  // Función para actualizar nota de cliente
  const actualizarNotaCliente = async (clienteId: number, nota: string) => {
    try {
      await api.put(`/clients/${clienteId}/nota-atraso`, { nota });
      // Actualizar estado local
      setAtrasosClientes(prev => prev.map((c: any) =>
        c.id === clienteId ? { ...c, notaAtraso: nota } : c
      ));
    } catch (error) {
      console.error('Error actualizando nota:', error);
      alert('Error al guardar la nota');
    }
  };

  // Función para actualizar nota de sucursal
  const actualizarNotaSucursal = async (clienteId: number, sucursalId: number, nota: string) => {
    try {
      await api.put(`/clients/branches/${sucursalId}/nota-atraso`, { nota });
      // Actualizar estado local
      setAtrasosClientes(prev => prev.map((c: any) => {
        if (c.id === clienteId) {
          return {
            ...c,
            sucursales: c.sucursales.map((s: any) =>
              s.id === sucursalId ? { ...s, notaAtraso: nota } : s
            )
          };
        }
        return c;
      }));
    } catch (error) {
      console.error('Error actualizando nota sucursal:', error);
      alert('Error al guardar la nota');
    }
  };

  // Función para verificar/desverificar cliente
  const toggleVerificacionCliente = async (clienteId: number, verificado: boolean) => {
    try {
      const response = await api.put(`/clients/${clienteId}/verificar-atraso`, { verificado });
      const data = response.data?.data;
      // Actualizar estado local
      setAtrasosClientes(prev => prev.map((c: any) =>
        c.id === clienteId ? {
          ...c,
          verificadoAtraso: data.verificadoAtraso,
          fechaVerificacionAtraso: data.fechaVerificacionAtraso,
          verificadoPorNombre: data.verificadoPorNombre
        } : c
      ));
    } catch (error) {
      console.error('Error actualizando verificación:', error);
      alert('Error al actualizar verificación');
    }
  };

  // Función para verificar/desverificar sucursal
  const toggleVerificacionSucursal = async (clienteId: number, sucursalId: number, verificado: boolean) => {
    try {
      const response = await api.put(`/clients/branches/${sucursalId}/verificar-atraso`, { verificado });
      const data = response.data?.data;
      // Actualizar estado local
      setAtrasosClientes(prev => prev.map((c: any) => {
        if (c.id === clienteId) {
          return {
            ...c,
            sucursales: c.sucursales.map((s: any) =>
              s.id === sucursalId ? {
                ...s,
                verificadoAtraso: data.verificadoAtraso,
                fechaVerificacionAtraso: data.fechaVerificacionAtraso,
                verificadoPorNombre: data.verificadoPorNombre
              } : s
            )
          };
        }
        return c;
      }));
    } catch (error) {
      console.error('Error actualizando verificación sucursal:', error);
      alert('Error al actualizar verificación');
    }
  };

  const getColorAtraso = (dias: number | null) => {
    if (dias === null) return '#ef4444'; // rojo - nunca tuvo
    if (dias > 90) return '#ef4444'; // rojo
    if (dias > 60) return '#f59e0b'; // amarillo
    if (dias > 30) return '#3b82f6'; // azul
    return '#10b981'; // verde
  };

  const cargarSucursales = async (clienteId: string) => {
    if (!clienteId) {
      setSucursalesCliente([]);
      return;
    }
    try {
      const response = await api.get(`/clients/${clienteId}/branches`);
      const sucursalesData = response.data?.data || response.data || [];
      setSucursalesCliente(Array.isArray(sucursalesData) ? sucursalesData : []);
    } catch (error) {
      setSucursalesCliente([]);
    }
  };

  // Cargar comisiones de ejecutivos
  const cargarComisiones = async () => {
    setLoadingComisiones(true);
    try {
      const params = filtroComisionEstado !== 'todos' ? `?estado=${filtroComisionEstado}` : '';
      const response = await api.get(`/finanzas/mis-comisiones${params}`);
      if (response.data.success) {
        setComisiones({
          lista: response.data.data || [],
          resumen: response.data.resumen || { totalPendiente: 0, totalPagado: 0, cantidadPendientes: 0, cantidadPagadas: 0 }
        });
      }
    } catch (error) {
      console.error('Error cargando comisiones:', error);
      setComisiones({ lista: [], resumen: { totalPendiente: 0, totalPagado: 0, cantidadPendientes: 0, cantidadPagadas: 0 } });
    } finally {
      setLoadingComisiones(false);
    }
  };

  // Pagar comisión individual
  const pagarComision = async (comisionId: number) => {
    try {
      const response = await api.post('/finanzas/pagar-comision', { comisionId });
      if (response.data.success) {
        cargarComisiones();
      }
    } catch (error) {
      console.error('Error pagando comisión:', error);
      alert('Error al pagar comisión');
    }
  };

  // Pagar todas las comisiones pendientes de un ejecutivo
  const pagarComisionesMasivo = async (ejecutivoId: number) => {
    const comisionesPendientes = comisiones.lista
      .filter(c => c.ejecutivo_id === ejecutivoId && c.estado === 'pendiente')
      .map(c => c.id);

    if (comisionesPendientes.length === 0) {
      alert('No hay comisiones pendientes para este ejecutivo');
      return;
    }

    if (!window.confirm(`¿Pagar ${comisionesPendientes.length} comisiones pendientes?`)) {
      return;
    }

    try {
      const response = await api.post('/finanzas/pagar-comisiones-masivo', { comisionIds: comisionesPendientes });
      if (response.data.success) {
        cargarComisiones();
      }
    } catch (error) {
      console.error('Error pagando comisiones:', error);
      alert('Error al pagar comisiones');
    }
  };

  const cargarDatos = async () => {
    setLoading(true);
    setError('');

    try {
      // Cargar datos del dashboard de finanzas
      const dashboardResp = await api.get('/finanzas/dashboard').catch(err => {
        console.error('Error cargando dashboard:', err);
        return null;
      });

      // USAR APIS SIMPLES QUE FUNCIONAN - TRAER TODOS LOS DATOS
      // Calcular fechas del mes seleccionado
      const primerDiaMes = new Date(anio, mes - 1, 1).toISOString().split('T')[0];
      const ultimoDiaMes = new Date(anio, mes, 0).toISOString().split('T')[0];

      const [auditoriasResp, movimientosResp] = await Promise.all([
        api.get('/audits?limit=1000&all=true&dateRange=all').catch(err => {
          console.error('Error cargando auditorías:', err);
          return { data: [] };
        }),
        api.get(`/finanzas/movimientos?tipo=INGRESO&fechaDesde=${primerDiaMes}&fechaHasta=${ultimoDiaMes}&limit=1000`).catch(err => {
          console.error('Error cargando movimientos financieros:', err);
          return { data: { movimientos: [] } };
        })
      ]);

      // Obtener auditorías - DEBUGGEAR DATOS
      const auditorias = auditoriasResp.data?.data || auditoriasResp.data || [];
      const movimientosFinancieros = movimientosResp.data?.movimientos || [];
      
      const porCobrar = auditorias.filter(a =>
        (a.estado === 'entregada' || a.estado === 'terminada') &&
        (a.estadoPago === null || a.estadoPago === 'pendiente') &&
        a.aprobada === true // SOLO aprobadas por supervisor
      );

      const cobradas = auditorias.filter(a => {
        if (a.estadoPago !== 'pagada' && a.estadoPago !== 'cobrada') return false;
        if (!a.fechaPago) return false;

        // Parsear fecha correctamente (evitar problemas de zona horaria)
        let fechaPago;
        if (typeof a.fechaPago === 'string' && a.fechaPago.includes('-')) {
          // Si es string formato 'YYYY-MM-DD', parsear como fecha local
          const [anioFecha, mesFecha, diaFecha] = a.fechaPago.split('T')[0].split('-');
          fechaPago = new Date(parseInt(anioFecha), parseInt(mesFecha) - 1, parseInt(diaFecha));
        } else {
          // Formato Date o timestamp
          fechaPago = new Date(a.fechaPago);
        }

        const mesAudit = fechaPago.getMonth() + 1;
        const anioAudit = fechaPago.getFullYear();

        return mesAudit === mes && anioAudit === anio;
      });
      

      // Cargar sueldos y gastos (mantener funcionalidad existente)
      const [sueldosResp, gastosResp] = await Promise.all([
        api.get('/sueldos').catch(err => {
          console.error('Error cargando sueldos:', err);
          return { data: [] };
        }),
        gastosApi.getAll().catch(() => ({ data: [] }))
      ]);
      
      // Calcular totales exactamente como el dashboard
      const calcularTotalConPrioridad = (auditorias) => {
        return auditorias.reduce((total, audit) => {
          // Ignorar auditorías gratuitas
          if (audit.gratisParaCliente) return total;
          
          // Usar costoFinal con valor por defecto de 100
          let monto = parseFloat(audit.costoFinal || 100);
          
          // Aplicar multiplicadores según prioridad
          if (audit.prioridad === 'prioritaria') {
            monto = monto * 1.5; // +50%
          } else if (audit.prioridad === 'urgente') {
            monto = monto * 2; // +100%
          }
          
          return total + monto;
        }, 0);
      };

      // CALCULAR TOTALES LOCALMENTE CON DEBUG
      const totalPorCobrar = porCobrar.reduce((total, a) => {
        const monto = parseFloat(a.costoFinal || 100);
        let montoFinal = monto;
        if (a.prioridad === 'prioritaria') {
          montoFinal = monto * 1.5;
        } else if (a.prioridad === 'urgente') {
          montoFinal = monto * 2;
        } else if (a.prioridad) {
        }
        return total + montoFinal;
      }, 0);
      

      // Calcular total cobrado del mes: auditorías + movimientos financieros
      let totalCobradoMes = 0;

      // Sumar auditorías cobradas del mes
      totalCobradoMes = cobradas.reduce((total, a) => {
        return total + parseFloat(a.costoFinal || 100);
      }, 0);

      // Sumar movimientos financieros (ingresos generales)
      const totalMovimientos = movimientosFinancieros.reduce((total, mov) => {
        return total + parseFloat(mov.monto || 0);
      }, 0);

      totalCobradoMes += totalMovimientos;

      // Cargar clientes con deuda agrupados por período
      let clientesConDeuda = [];
      let auditoriasPorCobrarExtraidas = [];
      try {
        const clientesResp = await api.get('/finanzas/clientes');
        clientesConDeuda = Array.isArray(clientesResp.data) ? clientesResp.data : [];
        console.log('📊 Clientes con deuda cargados:', clientesConDeuda.length);

        // OPTIMIZACIÓN: Extraer todas las auditorías de los períodos en un array plano
        // para que las funciones cobrarNormal, cobrarConPrioridad, etc. puedan usarlas
        clientesConDeuda.forEach(cliente => {
          cliente.periodos.forEach(periodo => {
            auditoriasPorCobrarExtraidas.push(...periodo.auditorias);
          });
        });
        console.log('📋 Auditorías extraídas:', auditoriasPorCobrarExtraidas.length);
      } catch (err) {
        console.error('Error cargando clientes con deuda:', err);
      }

      // OPTIMIZACIÓN: Usar las auditorías extraídas de clientesConDeuda si existen,
      // sino usar porCobrar (para mantener compatibilidad)
      const auditoriasFinal = auditoriasPorCobrarExtraidas.length > 0 ? auditoriasPorCobrarExtraidas : porCobrar;

      setIngresos({
        auditoriasPorCobrar: auditoriasFinal,
        auditoriasCobradasMes: cobradas,
        clientesConDeuda: clientesConDeuda,
        totalPorCobrar,
        totalCobradoMes: totalCobradoMes
      });

      // Procesar EGRESOS (Pagos a operadores y gastos)
      const sueldosData = sueldosResp.data?.data || sueldosResp.data || [];

      // Calcular mes y año para sueldos (mes pasado por defecto, mes actual si se selecciona)
      const fechaActual = new Date();
      const mesParaSueldos = mostrarSueldosMesActual ? mes :
        (mes === 1 ? 12 : mes - 1); // Si es enero, mes pasado es diciembre
      const anioParaSueldos = mostrarSueldosMesActual ? anio :
        (mes === 1 ? anio - 1 : anio); // Si es enero, año pasado

      // Obtener estadísticas reales de trabajo para calcular sueldos reales
      let estadisticasRealesTemp = {};
      try {
        const statsResponse = await workSessionApi.getEmployeeSummary(mesParaSueldos, anioParaSueldos);
        if (statsResponse.data.success && statsResponse.data.data && statsResponse.data.data.empleados) {
          statsResponse.data.data.empleados.forEach(empleado => {
            estadisticasRealesTemp[empleado.usuario.id] = empleado.estadisticas.totalComisiones || 0;
          });
        }
      } catch (error) {
        // Si falla la API, usar datos de sueldo como fallback
      }

      // Actualizar el estado con las estadísticas reales
      setEstadisticasReales(estadisticasRealesTemp);

      // Filtrar y eliminar duplicados por operadorId + mes + año
      const sueldosPendientesTemp = sueldosData.filter(s =>
        s.estado !== 'pagado' &&
        s.mes === mesParaSueldos &&
        s.anio === anioParaSueldos
      );

      const sueldosPagadosTemp = sueldosData.filter(s =>
        s.estado === 'pagado' &&
        s.mes === mesParaSueldos &&
        s.anio === anioParaSueldos
      );
      

      // Eliminar duplicados manteniendo el más reciente por operador
      const sueldosPendientes = sueldosPendientesTemp.reduce((acc, current) => {
        const existing = acc.find(item => 
          item.operadorId === current.operadorId && 
          item.mes === current.mes && 
          item.anio === current.anio
        );
        if (!existing) {
          acc.push(current);
        } else if (new Date(current.createdAt || current.updatedAt) > new Date(existing.createdAt || existing.updatedAt)) {
          // Reemplazar con el más reciente
          const index = acc.indexOf(existing);
          acc[index] = current;
        }
        return acc;
      }, []);

      const sueldosPagados = sueldosPagadosTemp.reduce((acc, current) => {
        const existing = acc.find(item => 
          item.operadorId === current.operadorId && 
          item.mes === current.mes && 
          item.anio === current.anio
        );
        if (!existing) {
          acc.push(current);
        } else if (new Date(current.createdAt || current.updatedAt) > new Date(existing.createdAt || existing.updatedAt)) {
          // Reemplazar con el más reciente
          const index = acc.indexOf(existing);
          acc[index] = current;
        }
        return acc;
      }, []);

      const gastosData = gastosResp.data || [];
      const gastosPeriodo = gastosData.filter(g => {
        const fecha = new Date(g.fecha || g.createdAt);
        return fecha.getMonth() + 1 === mes && fecha.getFullYear() === anio;
      });

      // Calcular totales usando sueldoFinal del backend (ya incluye francos)
      const totalSueldosPendientes = sueldosPendientes.reduce((total, s) => {
        return total + parseFloat(s.sueldoFinal || 0);
      }, 0);

      const totalSueldosPagados = sueldosPagados.reduce((total, s) => {
        return total + parseFloat(s.sueldoFinal || 0);
      }, 0);
      const totalGastos = gastosPeriodo.reduce((total, g) => 
        total + parseFloat(g.monto || 0), 0
      );

      // Por ahora, simulamos adelantos vacíos hasta implementar el backend
      const adelantos = [];
      const totalAdelantos = 0;

      setEgresos({
        sueldosPendientes,
        sueldosPagados,
        gastos: gastosPeriodo,
        adelantos,
        totalSueldosPendientes,
        totalSueldosPagados: totalSueldosPagados,
        totalGastos,
        totalAdelantos,
        mesParaSueldos,
        anioParaSueldos,
        esMesActual: mostrarSueldosMesActual
      });
      
      // CALCULAR BALANCE CON DATOS REALES
      const totalEgresosPendientes = totalSueldosPendientes; // Solo para información
      const totalEgresos = totalSueldosPagados + totalGastos + totalAdelantos;

      const gastosReales = totalSueldosPagados + totalGastos + totalAdelantos;

      // Los sueldos del mes actual no se incluyen en la proyección hasta el mes siguiente
      const sueldosParaProyeccion = mostrarSueldosMesActual ? 0 : totalSueldosPendientes;

      // Actualizar balance con datos del dashboard si están disponibles
      if (dashboardResp && dashboardResp.data && dashboardResp.data.resumen) {
        const { resumen } = dashboardResp.data;
        setBalance({
          ingresosTotales: totalPorCobrar + totalCobradoMes,
          egresosTotales: totalEgresos,
          balanceNeto: totalCobradoMes - gastosReales,
          proyeccion: totalPorCobrar - sueldosParaProyeccion,
          saldoMesAnterior: resumen.saldoMesAnterior || 0,
          ingresosMes: resumen.ingresosMes || 0,
          egresosMes: resumen.egresosMes || 0,
          movimientoMes: resumen.movimientoMes || 0,
          saldoRealTotal: resumen.saldoRealTotal || 0
        });
      } else {
        setBalance({
          ingresosTotales: totalPorCobrar + totalCobradoMes,
          egresosTotales: totalEgresos,
          balanceNeto: totalCobradoMes - gastosReales,
          proyeccion: totalPorCobrar - sueldosParaProyeccion,
          saldoMesAnterior: 0,
          ingresosMes: 0,
          egresosMes: 0,
          movimientoMes: 0,
          saldoRealTotal: 0
        });
      }

    } catch (err: any) {
      console.error('Error cargando datos:', err);
      setError('Error al cargar los datos financieros');
    } finally {
      setLoading(false);
    }
  };

  const formatMoney = (amount: number) => {
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS'
    }).format(amount);
  };

  const getColorForBalance = (amount: number) => {
    if (amount > 0) return '#10b981';
    if (amount < 0) return '#ef4444';
    return '#6b7280';
  };

  // Función para pagar sueldo
  const pagarSueldo = async (sueldo: any) => {
    if (!confirm(`¿Confirmar pago de $${sueldo.sueldoFinal || sueldo.monto} a ${sueldo.operador?.name || 'Operador'}?`)) return;
    
    try {
      // Usar el endpoint correcto con los parámetros esperados
      await api.post('/sueldos/pagar', { 
        sueldoId: sueldo.id,
        montoPago: sueldo.sueldoFinal || sueldo.monto,
        tipoPago: 'Pago Total',
        concepto: `Pago sueldo ${meses[mes - 1]} ${anio}`
      });
      alert('✅ Sueldo pagado exitosamente');
      cargarDatos();
    } catch (error) {
      console.error('Error pagando sueldo:', error);
      alert('❌ Error al pagar el sueldo');
    }
  };

  // Función para REVERTIR pago de sueldo
  const revertirPagoSueldo = async (sueldo: any) => {
    if (!confirm(`⚠️ ¿Está seguro de REVERTIR el pago de $${sueldo.sueldoFinal || sueldo.monto} a ${sueldo.operador?.name || 'Operador'}?`)) return;
    
    try {
      // Usar el endpoint de revertir con los parámetros esperados
      await api.post('/sueldos/revertir', { 
        sueldoId: sueldo.id,
        operadorId: sueldo.operadorId,
        monto: sueldo.sueldoFinal || sueldo.monto,
        motivo: `Reversión de pago ${meses[mes - 1]} ${anio}`
      });
      alert('↩️ Pago revertido. El sueldo está pendiente nuevamente');
      cargarDatos();
    } catch (error) {
      console.error('Error revirtiendo pago:', error);
      alert('❌ Error al revertir el pago');
    }
  };

  // Función para marcar auditoría como cobrada (CON PRIORIDAD)
  const marcarComoCobrada = async (auditId: number) => {
    const auditoria = ingresos.auditoriasPorCobrar.find(a => a.id === auditId);
    if (!auditoria) {
      alert('❌ Error: Auditoría no encontrada');
      return;
    }

    // Usar costoBase para calcular el precio correcto basado en prioridad
    const costoBase = parseFloat(auditoria.costoBase || 100);
    let montoFinal = costoBase;
    let multiplicador = 1.0;

    if (auditoria.prioridad === 'prioritaria') {
      montoFinal = costoBase * 1.5;
      multiplicador = 1.5;
    } else if (auditoria.prioridad === 'urgente') {
      montoFinal = costoBase * 2;
      multiplicador = 2.0;
    }
    
    const mensaje = auditoria.prioridad 
      ? `¿Cobrar ${auditoria.prioridad.toUpperCase()} por $${montoFinal.toLocaleString()}?`
      : `¿Cobrar por $${montoFinal.toLocaleString()}?`;
    
    if (!confirm(mensaje)) return;
    
    try {
      await api.patch(`/audits/${auditId}/pago`, {
        estadoPago: 'pagada',
        costoFinal: montoFinal,
        multiplicadorPrioridad: multiplicador
      });
      alert(`✅ Auditoría cobrada por $${montoFinal.toLocaleString()}`);
      cargarDatos();
    } catch (error) {
      console.error('Error:', error);
      alert('❌ Error al marcar la auditoría');
    }
  };

  // Función para cobrar SIN prioridad (precio normal)
  const cobrarNormal = async (auditId: number) => {
    const auditoria = ingresos.auditoriasPorCobrar.find(a => a.id === auditId);
    if (!auditoria) return;

    const montoNormal = parseFloat(auditoria.costoBase || 100);
    if (!confirm(`¿Cobrar NORMAL (sin prioridad) por $${montoNormal.toLocaleString()}?`)) return;

    try {
      await api.patch(`/audits/${auditId}/pago`, {
        estadoPago: 'pagada',
        costoFinal: montoNormal,
        multiplicadorPrioridad: 1.0,
        prioridad: 'normal'
      });
      alert(`✅ Auditoría cobrada NORMAL por $${montoNormal.toLocaleString()}`);
      cargarDatos();
    } catch (error) {
      alert('❌ Error al cobrar normal');
    }
  };

  // Función para marcar como GRATIS
  const marcarGratis = async (auditId: number) => {
    if (!confirm('¿Marcar esta auditoría como GRATUITA (sin cobro)?')) return;

    try {
      await api.patch(`/audits/${auditId}/pago`, {
        estadoPago: 'pagada',
        costoFinal: 0,
        multiplicadorPrioridad: 0,
        prioridad: 'normal',
        gratisParaCliente: true
      });
      alert('✅ Auditoría marcada como GRATUITA');
      cargarDatos();
    } catch (error) {
      alert('❌ Error al marcar como gratis');
    }
  };

  // Función para cobrar CON PRIORIDAD (precio duplicado)
  const cobrarConPrioridad = async (auditId: number) => {
    const auditoria = ingresos.auditoriasPorCobrar.find(a => a.id === auditId);
    if (!auditoria) return;

    const costoBase = parseFloat(auditoria.costoBase || 100);
    const montoDuplicado = costoBase * 2;

    if (!confirm(`¿Cobrar CON PRIORIDAD (precio duplicado) por $${montoDuplicado.toLocaleString()}?`)) return;

    try {
      await api.patch(`/audits/${auditId}/pago`, {
        estadoPago: 'pagada',
        costoFinal: montoDuplicado,
        multiplicadorPrioridad: 2.0,
        prioridad: 'urgente'
      });
      alert(`✅ Auditoría cobrada CON PRIORIDAD por $${montoDuplicado.toLocaleString()}`);
      cargarDatos();
    } catch (error) {
      alert('❌ Error al cobrar con prioridad');
    }
  };

  // Función para cobrar TODAS las auditorías de una empresa
  const cobrarPaqueteEmpresa = async (clienteId: number, clienteNombre: string) => {
    const auditoriasEmpresa = ingresos.auditoriasPorCobrar.filter(a => a.clientId === clienteId);
    
    let totalPaquete = 0;
    auditoriasEmpresa.forEach(a => {
      let monto = parseFloat(a.costoFinal || 100);
      if (a.prioridad === 'prioritaria') monto *= 1.5;
      if (a.prioridad === 'urgente') monto *= 2;
      totalPaquete += monto;
    });

    const mensaje = `¿Cobrar PAQUETE COMPLETO de ${clienteNombre}?\n` +
                   `${auditoriasEmpresa.length} auditorías por $${totalPaquete.toLocaleString()}`;
    
    if (!confirm(mensaje)) return;

    try {
      // Cobrar todas las auditorías de la empresa
      for (const auditoria of auditoriasEmpresa) {
        const costoBase = parseFloat(auditoria.costoBase || 100);
        let montoFinal = costoBase;
        let multiplicador = 1.0;

        if (auditoria.prioridad === 'prioritaria') {
          montoFinal = costoBase * 1.5;
          multiplicador = 1.5;
        } else if (auditoria.prioridad === 'urgente') {
          montoFinal = costoBase * 2;
          multiplicador = 2.0;
        }

        await api.patch(`/audits/${auditoria.id}/pago`, {
          estadoPago: 'pagada',
          costoFinal: montoFinal,
          multiplicadorPrioridad: multiplicador
        });
      }
      
      alert(`✅ PAQUETE COMPLETO cobrado: $${totalPaquete.toLocaleString()}`);
      cargarDatos();
    } catch (error) {
      alert('❌ Error cobrando paquete');
    }
  };

  // --- Funciones para checkboxes de selección de auditorías ---
  const toggleAuditoria = (clienteId: number, auditId: number) => {
    setSelectedPorCliente(prev => {
      const current = new Set(prev[clienteId] || []);
      if (current.has(auditId)) {
        current.delete(auditId);
      } else {
        current.add(auditId);
      }
      return { ...prev, [clienteId]: current };
    });
  };

  const getInfoSeleccion = (clienteId: number): { count: number; total: number } => {
    const selected = selectedPorCliente[clienteId];
    if (!selected || selected.size === 0) return { count: 0, total: 0 };

    const allAuditorias: any[] = [];
    const clienteDeuda = (ingresos.clientesConDeuda as any[]).find((c: any) => c.clienteId === clienteId);
    if (clienteDeuda) {
      clienteDeuda.periodos.forEach((periodo: any) => {
        allAuditorias.push(...periodo.auditorias);
      });
    }
    if (allAuditorias.length === 0) {
      allAuditorias.push(...(ingresos.auditoriasPorCobrar as any[]).filter((a: any) => a.clientId === clienteId));
    }

    let total = 0;
    allAuditorias.forEach((a: any) => {
      if (selected.has(a.id)) {
        total += parseFloat(a.costoFinal || 0);
      }
    });

    return { count: selected.size, total };
  };

  const cobrarSeleccionadas = (clienteId: number, clienteNombre: string) => {
    const selected = selectedPorCliente[clienteId];
    if (!selected || selected.size === 0) return;

    const allAuditorias: any[] = [];
    const clienteDeuda = (ingresos.clientesConDeuda as any[]).find((c: any) => c.clienteId === clienteId);
    if (clienteDeuda) {
      clienteDeuda.periodos.forEach((periodo: any) => {
        allAuditorias.push(...periodo.auditorias);
      });
    }
    if (allAuditorias.length === 0) {
      allAuditorias.push(...(ingresos.auditoriasPorCobrar as any[]).filter((a: any) => a.clientId === clienteId));
    }

    const seleccionadas = allAuditorias.filter((a: any) => selected.has(a.id));
    if (seleccionadas.length === 0) return;

    abrirModalCobro(clienteId, clienteNombre, mes, anio, seleccionadas);
  };

  // Función para abrir modal de cobro
  const abrirModalCobro = (clienteId: number, clienteNombre: string, mes: number, anio: number, auditorias: any[]) => {
    const totalPeriodo = auditorias.reduce((sum: number, a: any) => sum + parseFloat(a.costoFinal || 0), 0);
    setCobroData({ clienteId, clienteNombre, mes, anio, auditorias, totalPeriodo });
    setCobroDetalle('');
    setCobroFactura(null);
    setShowModalCobro(true);
  };

  // Función para COBRAR PERÍODO completo (mes)
  const cobrarPeriodo = async () => {
    if (!cobroData) return;

    const { clienteId, mes, anio, auditorias, totalPeriodo } = cobroData;
    const mesesNombres = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                          'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

    if (!cobroDetalle.trim()) {
      alert('⚠️ Debe especificar el detalle del cobro');
      return;
    }

    setProcesandoCobro(true);

    try {
      const auditoriaIds = auditorias.map((a: any) => a.id);

      // Si hay factura adjunta, enviar con FormData
      let response;
      if (cobroFactura) {
        const formData = new FormData();
        formData.append('clienteId', clienteId.toString());
        formData.append('mes', mes.toString());
        formData.append('anio', anio.toString());
        formData.append('auditoriaIds', JSON.stringify(auditoriaIds));
        formData.append('detalle', cobroDetalle.trim());
        formData.append('factura', cobroFactura);

        response = await api.post('/finanzas/cobrar-periodo', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
      } else {
        response = await api.post('/finanzas/cobrar-periodo', {
          clienteId,
          mes,
          anio,
          auditoriaIds,
          detalle: cobroDetalle.trim()
        });
      }

      let mensaje = `✅ Período ${mesesNombres[mes - 1]} ${anio} cobrado: $${totalPeriodo.toLocaleString()}`;

      // Si se generó comisión, mostrarla
      if (response.data.comision) {
        mensaje += `\n\n💰 Comisión generada: $${response.data.comision.monto.toLocaleString()} (${response.data.comision.tipo})`;
      }

      if (cobroFactura) {
        mensaje += '\n\n📎 Factura adjuntada al email';
      }

      alert(mensaje);
      // Limpiar selección del cliente cobrado
      if (cobroData.clienteId) {
        setSelectedPorCliente(prev => {
          const next = { ...prev };
          delete next[cobroData.clienteId];
          return next;
        });
      }
      setShowModalCobro(false);
      setCobroData(null);
      setCobroDetalle('');
      setCobroFactura(null);
      cargarDatos();
    } catch (error: any) {
      console.error('Error cobrando período:', error);
      alert('❌ ' + (error.response?.data?.error || 'Error cobrando período'));
    } finally {
      setProcesandoCobro(false);
    }
  };

  // Función para EDITAR auditoría/cobro manual
  const editarAuditoria = async (auditId: number, auditTitulo: string, auditCosto: number, auditFecha: string) => {
    const nuevoTitulo = prompt('Título:', auditTitulo);
    if (nuevoTitulo === null) return; // Cancelado

    const nuevoCostoStr = prompt('Monto ($):', auditCosto.toString());
    if (nuevoCostoStr === null) return; // Cancelado

    const nuevoCosto = parseFloat(nuevoCostoStr);
    if (isNaN(nuevoCosto) || nuevoCosto <= 0) {
      alert('❌ Monto inválido');
      return;
    }

    // Pedir nueva fecha (formato YYYY-MM-DD)
    const fechaFormateada = auditFecha ? new Date(auditFecha).toISOString().split('T')[0] : new Date().toISOString().split('T')[0];
    const nuevaFechaStr = prompt('Fecha (YYYY-MM-DD):', fechaFormateada);
    if (nuevaFechaStr === null) return; // Cancelado

    // Validar formato de fecha
    if (!/^\d{4}-\d{2}-\d{2}$/.test(nuevaFechaStr)) {
      alert('❌ Formato de fecha inválido. Use YYYY-MM-DD');
      return;
    }

    try {
      await api.put(`/finanzas/editar-auditoria/${auditId}`, {
        titulo: nuevoTitulo,
        costoFinal: nuevoCosto,
        fechaSolicitada: nuevaFechaStr
      });

      alert('✅ Auditoría actualizada');
      cargarDatos();
    } catch (error) {
      console.error('Error editando auditoría:', error);
      alert('❌ Error editando auditoría');
    }
  };

  // Función para BORRAR auditoría/cobro manual
  const borrarAuditoria = async (auditId: number, auditTitulo: string) => {
    if (!confirm(`⚠️ ¿Está seguro de BORRAR "${auditTitulo}"?\nEsta acción no se puede deshacer.`)) return;

    try {
      await api.delete(`/finanzas/borrar-auditoria/${auditId}`);

      alert('🗑️ Auditoría eliminada');
      cargarDatos();
    } catch (error) {
      console.error('Error borrando auditoría:', error);
      alert('❌ Error eliminando auditoría: ' + (error.response?.data?.error || error.message));
    }
  };

  // Función para REVERTIR cobro de auditoría
  const revertirCobro = async (auditId: number) => {
    if (!confirm('⚠️ ¿Está seguro de REVERTIR este cobro? La auditoría volverá a pendiente de cobro')) return;
    
    try {
      // Usar el mismo endpoint pero cambiar estado a pendiente
      await api.patch(`/audits/${auditId}/pago`, { 
        estadoPago: 'pendiente' 
      });
      alert('↩️ Cobro revertido. La auditoría está pendiente nuevamente');
      cargarDatos();
    } catch (error) {
      console.error('Error revirtiendo cobro:', error);
      alert('❌ Error al revertir el cobro');
    }
  };

  // Función para registrar nuevo gasto
  const registrarGasto = async () => {
    if (!nuevoGasto.descripcion || !nuevoGasto.monto) {
      alert('⚠️ Complete todos los campos');
      return;
    }
    
    // Validación especial para contables
    if (user?.role === 'contable' && (!nuevoGasto.explicacion || nuevoGasto.explicacion.trim().length < 15)) {
      alert('⚠️ CONTABLE: Debe proporcionar una explicación detallada (mínimo 15 caracteres) sobre la necesidad de este gasto');
      return;
    }
    
    try {
      const response = await gastosApi.create(nuevoGasto);
      alert('✅ Gasto registrado exitosamente');
      setNuevoGasto({ descripcion: '', monto: '', categoria: 'operativo', fecha: new Date().toISOString().split('T')[0], explicacion: '' });
      setMostrarFormGasto(false);
      cargarDatos();
    } catch (error) {
      console.error('❌ Error registrando gasto:', error);
      alert(`❌ Error al registrar el gasto: ${error.response?.data?.message || error.message}`);
    }
  };

  const crearGastosExistentes = async () => {
    try {
      const response = await api.post('/sueldos/crear-gastos-existentes');
      alert(`✅ ${response.data.message}`);
      cargarDatos(); // Recargar datos
    } catch (error: any) {
      console.error('Error creando gastos existentes:', error);
      alert(`❌ Error: ${error.response?.data?.message || error.message}`);
    }
  };

  const revertirGasto = async (gastoId: number, descripcion: string) => {
    if (!confirm(`¿Está seguro de revertir el gasto: ${descripcion}?`)) {
      return;
    }

    try {
      await gastosApi.delete(gastoId);
      alert('✅ Gasto revertido exitosamente');
      cargarDatos(); // Recargar datos para actualizar la lista
    } catch (error) {
      console.error('Error revirtiendo gasto:', error);
      alert('❌ Error al revertir el gasto');
    }
  };

  // Función para registrar ingreso manual
  const registrarIngresoManual = async (clienteId: string, clienteNombre: string) => {
    if (!ingresoManual.titulo || !ingresoManual.monto) {
      alert('⚠️ Complete el título y el monto');
      return;
    }

    if (!confirm(`¿Registrar ingreso manual de ${formatMoney(parseFloat(ingresoManual.monto))} para ${clienteNombre}?`)) {
      return;
    }

    try {
      // Crear una auditoría "ficticia" como ingreso manual
      await api.post('/audits/ingreso-manual', {
        clienteId: parseInt(clienteId),
        titulo: ingresoManual.titulo,
        costoFinal: parseFloat(ingresoManual.monto),
        fecha: ingresoManual.fecha,
        estadoPago: 'pagada',
        tipo: 'ingreso_manual'
      });

      alert('✅ Ingreso manual registrado exitosamente');
      setMostrarFormIngresoManual(null);
      setIngresoManual({
        clienteId: '',
        titulo: '',
        monto: '',
        fecha: new Date().toISOString().split('T')[0]
      });
      cargarDatos();
    } catch (error) {
      console.error('Error registrando ingreso:', error);
      alert('❌ Error al registrar el ingreso');
    }
  };

  // Función para registrar ingreso universal
  const registrarIngresoUniversal = async () => {
    if (!ingresoUniversal.titulo || !ingresoUniversal.monto) {
      alert('⚠️ Complete título y monto');
      return;
    }

    const cliente = clientes.find((c: any) => c.id == ingresoUniversal.clienteId);
    const clienteNombre = cliente?.nombre || 'Ingreso General';

    const mensaje = ingresoUniversal.clienteId
      ? `¿Registrar ingreso de ${formatMoney(parseFloat(ingresoUniversal.monto))} para ${clienteNombre}?`
      : `¿Registrar ingreso general de ${formatMoney(parseFloat(ingresoUniversal.monto))} (sin cliente asociado)?`;

    if (!confirm(mensaje)) {
      return;
    }

    try {
      await api.post('/audits/ingreso-manual', {
        clienteId: ingresoUniversal.clienteId ? parseInt(ingresoUniversal.clienteId) : null,
        titulo: ingresoUniversal.titulo,
        costoFinal: parseFloat(ingresoUniversal.monto),
        fecha: ingresoUniversal.fecha,
        estadoPago: 'pagada',
        tipo: 'ingreso_manual'
      });

      alert('✅ Ingreso registrado. Aparecerá en "Pendiente de Cobro" hasta que lo marques como pagado.');
      setMostrarFormIngresoUniversal(false);
      setIngresoUniversal({
        clienteId: '',
        titulo: '',
        monto: '',
        fecha: new Date().toISOString().split('T')[0]
      });
      cargarDatos();
    } catch (error) {
      console.error('Error registrando ingreso:', error);
      alert('❌ Error al registrar el ingreso');
    }
  };

  // Los datos se cargan en el useEffect principal arriba

  return (
    <div style={{ padding: '20px' }}>
      {/* Header con título y período */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        marginBottom: '30px',
        borderBottom: '2px solid #e5e7eb',
        paddingBottom: '20px'
      }}>
        <h1 style={{ margin: 0, fontSize: '2rem', fontWeight: 'bold' }}>
          💰 Sistema Completo de Finanzas
        </h1>
        
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <select 
            value={mes} 
            onChange={(e) => setMes(Number(e.target.value))}
            style={{
              padding: '8px 12px',
              borderRadius: '6px',
              border: '1px solid #d1d5db',
              fontSize: '14px'
            }}
          >
            {meses.map((m, i) => (
              <option key={i} value={i + 1}>{m}</option>
            ))}
          </select>
          
          <select 
            value={anio} 
            onChange={(e) => setAnio(Number(e.target.value))}
            style={{
              padding: '8px 12px',
              borderRadius: '6px',
              border: '1px solid #d1d5db',
              fontSize: '14px'
            }}
          >
            {[2024, 2025, 2026].map(y => (
              <option key={y} value={y}>{y}</option>
            ))}
          </select>
          
          <button
            onClick={cargarDatos}
            disabled={loading}
            style={{
              padding: '8px 16px',
              background: loading ? '#9ca3af' : '#3b82f6',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: loading ? 'not-allowed' : 'pointer',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            {loading ? '⏳ Cargando...' : '🔄 Actualizar'}
          </button>
        </div>
      </div>

      {/* Tabs de navegación */}
      <div style={{ 
        display: 'flex', 
        gap: '4px',
        marginBottom: '30px',
        borderBottom: '1px solid #e5e7eb'
      }}>
        {[
          { id: 'resumen', label: '📊 Resumen' },
          { id: 'ingresos', label: '💵 Ingresos' },
          { id: 'egresos', label: '💸 Egresos' },
          { id: 'personal', label: '👥 Personal' },
          { id: 'balance', label: '⚖️ Balance' },
          { id: 'atraso-clientes', label: '⏰ Atraso Clientes' },
          { id: 'comisiones', label: '💰 Comisiones' },
          { id: 'configuracion', label: '⚙️ Configuración' }
        ].map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id as any)}
            style={{
              padding: '12px 24px',
              background: activeTab === tab.id ? '#3b82f6' : 'transparent',
              color: activeTab === tab.id ? 'white' : '#6b7280',
              border: 'none',
              borderBottom: activeTab === tab.id ? '3px solid #3b82f6' : 'none',
              cursor: 'pointer',
              fontSize: '15px',
              fontWeight: activeTab === tab.id ? '600' : '400',
              transition: 'all 0.2s'
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Contenido según tab activa */}
      {error && (
        <div style={{
          padding: '12px',
          background: '#fef2f2',
          border: '1px solid #fecaca',
          borderRadius: '6px',
          color: '#dc2626',
          marginBottom: '20px'
        }}>
          ⚠️ {error}
        </div>
      )}

      {/* TAB RESUMEN */}
      {activeTab === 'resumen' && (
        <div>
          {/* Métricas principales como el dashboard */}
          <div style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            borderRadius: '12px',
            padding: '25px',
            marginBottom: '30px',
            color: 'white'
          }}>
            <h2 style={{ margin: '0 0 20px 0', fontSize: '1.5rem' }}>📊 Resumen Financiero</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px' }}>
              <div>
                <p style={{ margin: '0 0 5px 0', opacity: 0.9, fontSize: '0.875rem' }}>Total Cobrado</p>
                <p style={{ margin: 0, fontSize: '2rem', fontWeight: 'bold' }}>{formatMoney(ingresos.totalCobradoMes)}</p>
              </div>
              <div>
                <p style={{ margin: '0 0 5px 0', opacity: 0.9, fontSize: '0.875rem' }}>Por Cobrar</p>
                <p style={{ margin: 0, fontSize: '2rem', fontWeight: 'bold' }}>{formatMoney(ingresos.totalPorCobrar)}</p>
              </div>
              <div>
                <p style={{ margin: '0 0 5px 0', opacity: 0.9, fontSize: '0.875rem' }}>Saldo Real</p>
                <p style={{ margin: 0, fontSize: '2rem', fontWeight: 'bold' }}>{formatMoney(balance.saldoRealTotal)}</p>
              </div>
            </div>
          </div>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
          {/* Card Ingresos */}
          <div style={{
            background: '#f0fdf4',
            border: '2px solid #86efac',
            borderRadius: '12px',
            padding: '20px'
          }}>
            <h3 style={{ margin: '0 0 20px 0', color: '#166534', fontSize: '1.25rem' }}>
              💵 Ingresos del Mes
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Cobrado:</span>
                <span style={{ fontWeight: 'bold', color: '#166534' }}>
                  {formatMoney(ingresos.totalCobradoMes)}
                </span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Por Cobrar:</span>
                <span style={{ fontWeight: 'bold', color: '#ca8a04' }}>
                  {formatMoney(ingresos.totalPorCobrar)}
                </span>
              </div>
              <hr style={{ border: 'none', borderTop: '1px solid #d1d5db' }} />
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '1.125rem' }}>
                <span>Total Proyectado:</span>
                <span style={{ fontWeight: 'bold', color: '#166534' }}>
                  {formatMoney(ingresos.totalCobradoMes + ingresos.totalPorCobrar)}
                </span>
              </div>
            </div>
          </div>

          {/* Card Egresos */}
          <div style={{
            background: '#fef2f2',
            border: '2px solid #fca5a5',
            borderRadius: '12px',
            padding: '20px'
          }}>
            <h3 style={{ margin: '0 0 20px 0', color: '#991b1b', fontSize: '1.25rem' }}>
              💸 Egresos del Mes
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Sueldos Pagados:</span>
                <span style={{ fontWeight: 'bold', color: '#991b1b' }}>
                  {formatMoney(egresos.totalSueldosPagados)}
                </span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Sueldos Pendientes:</span>
                <span style={{ fontWeight: 'bold', color: '#ca8a04' }}>
                  {formatMoney(egresos.totalSueldosPendientes)}
                </span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Gastos:</span>
                <span style={{ fontWeight: 'bold', color: '#991b1b' }}>
                  {formatMoney(egresos.totalGastos + egresos.totalSueldosPagados)}
                </span>
              </div>
              <hr style={{ border: 'none', borderTop: '1px solid #d1d5db' }} />
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '1.125rem' }}>
                <span>Total:</span>
                <span style={{ fontWeight: 'bold', color: '#991b1b' }}>
                  {formatMoney(egresos.totalSueldosPagados + egresos.totalGastos)}
                </span>
              </div>
            </div>
          </div>

          {/* Card Balance */}
          <div style={{
            background: '#f0f9ff',
            border: '2px solid #93c5fd',
            borderRadius: '12px',
            padding: '20px'
          }}>
            <h3 style={{ margin: '0 0 20px 0', color: '#1e3a8a', fontSize: '1.25rem' }}>
              ⚖️ Balance General
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Saldo Real:</span>
                <span style={{
                  fontWeight: 'bold',
                  color: getColorForBalance(balance.saldoRealTotal),
                  fontSize: '1.125rem'
                }}>
                  {formatMoney(balance.saldoRealTotal)}
                </span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Proyección:</span>
                <span style={{
                  fontWeight: 'bold',
                  color: getColorForBalance(balance.proyeccion)
                }}>
                  {formatMoney(balance.proyeccion)}
                </span>
              </div>
            </div>
          </div>
        </div>
        </div>
      )}

      {/* TAB INGRESOS */}
      {activeTab === 'ingresos' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h2 style={{ margin: 0 }}>💵 Detalle de Ingresos - {meses[mes - 1]} {anio}</h2>

            <button
              onClick={() => setMostrarFormIngresoUniversal(!mostrarFormIngresoUniversal)}
              style={{
                padding: '12px 24px',
                backgroundColor: '#10b981',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '14px'
              }}
            >
              ➕ Registrar Ingreso Manual
            </button>
          </div>

          {/* Formulario Universal de Ingreso Manual */}
          {mostrarFormIngresoUniversal && (
            <div style={{
              marginBottom: '30px',
              padding: '20px',
              backgroundColor: '#f0fdf4',
              border: '2px solid #86efac',
              borderRadius: '12px'
            }}>
              <h3 style={{ margin: '0 0 15px 0', color: '#166534' }}>
                Registrar Ingreso Manual
              </h3>

              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500', fontSize: '14px', color: '#374151' }}>
                  Cliente (opcional)
                </label>
                <select
                  value={ingresoUniversal.clienteId}
                  onChange={(e) => {
                    setIngresoUniversal({...ingresoUniversal, clienteId: e.target.value});
                  }}
                  style={{
                    padding: '12px',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '14px',
                    width: '100%'
                  }}
                >
                  <option value="">Sin cliente (ingreso general)</option>
                  {Array.isArray(clientes) && clientes.map((cliente: any) => (
                    <option key={cliente.id} value={cliente.id}>
                      {cliente.nombre}
                    </option>
                  ))}
                </select>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: '15px', marginBottom: '15px' }}>
                <input
                  type="text"
                  placeholder="Título (ej: Pedido del día 30/09 por video - Sucursal Centro)"
                  value={ingresoUniversal.titulo}
                  onChange={(e) => setIngresoUniversal({...ingresoUniversal, titulo: e.target.value})}
                  style={{
                    padding: '12px',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '14px'
                  }}
                />

                <input
                  type="number"
                  placeholder="Monto ($)"
                  value={ingresoUniversal.monto}
                  onChange={(e) => setIngresoUniversal({...ingresoUniversal, monto: e.target.value})}
                  style={{
                    padding: '12px',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '14px'
                  }}
                />

                <input
                  type="date"
                  value={ingresoUniversal.fecha}
                  onChange={(e) => setIngresoUniversal({...ingresoUniversal, fecha: e.target.value})}
                  style={{
                    padding: '12px',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '14px'
                  }}
                />
              </div>

              <div style={{ display: 'flex', gap: '10px' }}>
                <button
                  onClick={registrarIngresoUniversal}
                  style={{
                    padding: '10px 20px',
                    backgroundColor: '#10b981',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontWeight: '500'
                  }}
                >
                  ✓ Registrar
                </button>
                <button
                  onClick={() => {
                    setMostrarFormIngresoUniversal(false);
                    setIngresoUniversal({
                      clienteId: '',
                      titulo: '',
                      monto: '',
                      fecha: new Date().toISOString().split('T')[0]
                    });
                  }}
                  style={{
                    padding: '10px 20px',
                    backgroundColor: '#6b7280',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer'
                  }}
                >
                  Cancelar
                </button>
              </div>
            </div>
          )}

          {/* Auditorías por Cobrar */}
          <div style={{ marginBottom: '30px' }}>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center',
              marginBottom: '15px'
            }}>
              <h3 style={{ 
                margin: '0',
                padding: '10px',
                background: '#fef3c7',
                borderRadius: '6px',
                color: '#92400e'
              }}>
                📋 Auditorías Pendientes de Cobro ({ingresos.auditoriasPorCobrar.length})
              </h3>
              <div style={{
                background: '#f0fdf4',
                border: '2px solid #86efac',
                borderRadius: '8px',
                padding: '10px 15px'
              }}>
                <div style={{ fontSize: '0.875rem', color: '#166534', marginBottom: '2px' }}>Total Cobrado este mes:</div>
                <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#166534' }}>
                  {formatMoney(ingresos.totalCobradoMes)}
                </div>
              </div>
            </div>

            {/* Buscador por nombre y selector de vista */}
            <div style={{ marginBottom: '20px', display: 'flex', gap: '10px', alignItems: 'center' }}>
              <input
                type="text"
                placeholder="🔍 Buscar por nombre de cliente..."
                value={filtroNombre}
                onChange={(e) => setFiltroNombre(e.target.value)}
                style={{
                  flex: 1,
                  padding: '12px',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '14px'
                }}
              />
              <button
                onClick={() => setVistaPorMes(!vistaPorMes)}
                style={{
                  padding: '12px 20px',
                  backgroundColor: vistaPorMes ? '#3b82f6' : '#6b7280',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  whiteSpace: 'nowrap'
                }}
              >
                {vistaPorMes ? '📅 Por Mes' : '🏢 Por Empresa'}
              </button>
            </div>

            {ingresos.auditoriasPorCobrar.length === 0 && ingresos.clientesConDeuda.length === 0 ? (
              <p style={{ color: '#6b7280', textAlign: 'center', padding: '20px' }}>
                No hay auditorías pendientes de cobro
              </p>
            ) : vistaPorMes ? (
              // VISTA POR MES (NUEVA)
              (() => {
                const clientesFiltrados = ingresos.clientesConDeuda.filter(cliente => {
                  const clienteNombre = cliente.clienteNombre.toLowerCase();
                  return filtroNombre === '' || clienteNombre.includes(filtroNombre.toLowerCase());
                });

                return (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '30px' }}>
                    {clientesFiltrados.map((cliente: any) => (
                      <div key={cliente.clienteId} style={{
                        border: '2px solid #e5e7eb',
                        borderRadius: '12px',
                        overflow: 'hidden'
                      }}>
                        {/* HEADER DEL CLIENTE */}
                        <div style={{
                          background: '#f3f4f6',
                          padding: '15px 20px',
                          borderBottom: '1px solid #e5e7eb'
                        }}>
                          <div>
                            <h4 style={{ margin: '0 0 5px 0', fontSize: '1.25rem', fontWeight: 'bold' }}>
                              🏢 {cliente.clienteNombre}
                              {cliente.clienteCuit && (
                                <span style={{
                                  marginLeft: '12px',
                                  fontSize: '0.85rem',
                                  fontWeight: 'normal',
                                  color: '#6b7280',
                                  background: '#e5e7eb',
                                  padding: '2px 8px',
                                  borderRadius: '4px'
                                }}>
                                  CUIT: {cliente.clienteCuit}
                                </span>
                              )}
                            </h4>
                            <p style={{ margin: 0, color: '#6b7280' }}>
                              Total Deuda: {formatMoney(cliente.totalDeuda)} • {cliente.periodos.length} período(s)
                            </p>
                          </div>
                        </div>

                        {/* PERÍODOS */}
                        {cliente.periodos.map((periodo: any) => {
                          const mesesNombres = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                                                'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
                          const nombreMes = mesesNombres[periodo.mes - 1];

                          return (
                            <div key={periodo.mesAnio} style={{
                              borderTop: '1px solid #e5e7eb',
                              background: '#fafafa'
                            }}>
                              {/* Header del Período */}
                              <div style={{
                                padding: '12px 20px',
                                background: '#fff7ed',
                                borderBottom: '1px solid #fed7aa',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                              }}>
                                <div>
                                  <strong style={{ fontSize: '1.1rem', color: '#ea580c' }}>
                                    📅 {nombreMes} {periodo.anio}
                                  </strong>
                                  <span style={{ marginLeft: '10px', color: '#9ca3af' }}>
                                    {periodo.auditorias.length} auditorías • {formatMoney(periodo.totalPeriodo)}
                                  </span>
                                </div>
                                <button
                                  onClick={() => abrirModalCobro(cliente.clienteId, cliente.nombre, periodo.mes, periodo.anio, periodo.auditorias)}
                                  style={{
                                    padding: '8px 16px',
                                    backgroundColor: '#10b981',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    fontWeight: 'bold',
                                    fontSize: '13px'
                                  }}
                                >
                                  💰 COBRAR PERÍODO COMPLETO
                                </button>
                              </div>

                              {/* Tabla de Auditorías del Período */}
                              <div style={{ overflowX: 'auto' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse', background: 'white' }}>
                                  <thead>
                                    <tr style={{ background: '#f9fafb' }}>
                                      <th style={{ padding: '10px', width: '40px', textAlign: 'center', borderBottom: '1px solid #e5e7eb' }}>
                                        <input
                                          type="checkbox"
                                          checked={periodo.auditorias.length > 0 && periodo.auditorias.every((a: any) => selectedPorCliente[cliente.clienteId]?.has(a.id))}
                                          onChange={() => {
                                            const allIds = periodo.auditorias.map((a: any) => a.id);
                                            const allSelected = allIds.every((id: number) => selectedPorCliente[cliente.clienteId]?.has(id));
                                            setSelectedPorCliente(prev => {
                                              const current = new Set(prev[cliente.clienteId] || []);
                                              if (allSelected) {
                                                allIds.forEach((id: number) => current.delete(id));
                                              } else {
                                                allIds.forEach((id: number) => current.add(id));
                                              }
                                              return { ...prev, [cliente.clienteId]: current };
                                            });
                                          }}
                                          title="Seleccionar todas del período"
                                        />
                                      </th>
                                      <th style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid #e5e7eb', fontSize: '13px' }}>Auditoría</th>
                                      <th style={{ padding: '10px', textAlign: 'right', borderBottom: '1px solid #e5e7eb', fontSize: '13px' }}>Monto</th>
                                      <th style={{ padding: '10px', textAlign: 'center', borderBottom: '1px solid #e5e7eb', fontSize: '13px' }}>Fecha</th>
                                      <th style={{ padding: '10px', textAlign: 'center', borderBottom: '1px solid #e5e7eb', fontSize: '13px' }}>Acciones</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {periodo.auditorias.map((audit: any) => (
                                      <tr key={audit.id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                                        <td style={{ padding: '10px', textAlign: 'center' }}>
                                          <input
                                            type="checkbox"
                                            checked={selectedPorCliente[cliente.clienteId]?.has(audit.id) || false}
                                            onChange={() => toggleAuditoria(cliente.clienteId, audit.id)}
                                          />
                                        </td>
                                        <td style={{ padding: '10px', fontSize: '13px' }}>
                                          {audit.titulo && audit.titulo.trim() !== '' && audit.titulo !== `Auditoría #${audit.id}`
                                            ? audit.titulo
                                            : `Auditoría #${audit.id}`}
                                          {audit.tipoIngresoManual && (
                                            <span style={{
                                              marginLeft: '8px',
                                              padding: '2px 6px',
                                              background: '#dbeafe',
                                              color: '#1e40af',
                                              borderRadius: '3px',
                                              fontSize: '10px',
                                              fontWeight: 'bold'
                                            }}>
                                              MANUAL
                                            </span>
                                          )}
                                        </td>
                                        <td style={{ padding: '10px', textAlign: 'right', fontWeight: 'bold', color: '#166534', fontSize: '13px' }}>
                                          {formatMoney(parseFloat(audit.costoFinal || 0))}
                                        </td>
                                        <td style={{ padding: '10px', textAlign: 'center', fontSize: '12px', color: '#6b7280' }}>
                                          {new Date(audit.fechaSolicitada || audit.createdAt).toLocaleDateString('es-AR')}
                                        </td>
                                        <td style={{ padding: '10px', textAlign: 'center' }}>
                                          <div style={{ display: 'flex', gap: '4px', justifyContent: 'center', flexWrap: 'wrap' }}>
                                            <button
                                              onClick={() => marcarGratis(audit.id)}
                                              style={{
                                                padding: '4px 8px',
                                                backgroundColor: '#10b981',
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '3px',
                                                cursor: 'pointer',
                                                fontSize: '10px',
                                                fontWeight: 'bold'
                                              }}
                                              title="Marcar como Gratis"
                                            >
                                              🎁
                                            </button>
                                            <button
                                              onClick={() => cobrarNormal(audit.id)}
                                              style={{
                                                padding: '4px 8px',
                                                backgroundColor: '#3b82f6',
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '3px',
                                                cursor: 'pointer',
                                                fontSize: '10px',
                                                fontWeight: 'bold'
                                              }}
                                              title="Cobrar Normal"
                                            >
                                              💵
                                            </button>
                                            <button
                                              onClick={() => cobrarConPrioridad(audit.id)}
                                              style={{
                                                padding: '4px 8px',
                                                backgroundColor: '#f59e0b',
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '3px',
                                                cursor: 'pointer',
                                                fontSize: '10px',
                                                fontWeight: 'bold'
                                              }}
                                              title="Cobrar Urgente (x2)"
                                            >
                                              ⚡
                                            </button>
                                            <button
                                              onClick={() => editarAuditoria(audit.id, audit.titulo || `Auditoría #${audit.id}`, audit.costoFinal, audit.fechaSolicitada)}
                                              style={{
                                                padding: '4px 8px',
                                                backgroundColor: '#6b7280',
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '3px',
                                                cursor: 'pointer',
                                                fontSize: '10px'
                                              }}
                                              title="Editar"
                                            >
                                              ✏️
                                            </button>
                                            <button
                                              onClick={() => borrarAuditoria(audit.id, audit.titulo || `Auditoría #${audit.id}`)}
                                              style={{
                                                padding: '4px 8px',
                                                backgroundColor: '#ef4444',
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '3px',
                                                cursor: 'pointer',
                                                fontSize: '10px'
                                              }}
                                              title="Borrar"
                                            >
                                              🗑️
                                            </button>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          );
                        })}

                        {/* Barra de seleccionadas */}
                        {(() => {
                          const info = getInfoSeleccion(cliente.clienteId);
                          if (info.count === 0) return null;
                          return (
                            <div style={{
                              padding: '12px 20px',
                              background: '#eff6ff',
                              borderTop: '2px solid #3b82f6',
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center'
                            }}>
                              <span style={{ color: '#1e40af', fontWeight: 'bold' }}>
                                {info.count} seleccionada(s) - {formatMoney(info.total)}
                              </span>
                              <button
                                onClick={() => cobrarSeleccionadas(cliente.clienteId, cliente.clienteNombre)}
                                style={{
                                  padding: '8px 16px',
                                  backgroundColor: '#3b82f6',
                                  color: 'white',
                                  border: 'none',
                                  borderRadius: '6px',
                                  cursor: 'pointer',
                                  fontWeight: 'bold',
                                  fontSize: '13px'
                                }}
                              >
                                COBRAR SELECCIONADAS
                              </button>
                            </div>
                          );
                        })()}
                      </div>
                    ))}
                  </div>
                );
              })()
            ) : (
              // VISTA POR EMPRESA (ORIGINAL)
              (() => {
                const empresas = {};
                // Filtrar por nombre si hay filtro
                const auditoriasFiltradas = ingresos.auditoriasPorCobrar.filter(audit => {
                  const clienteNombre = (audit.client?.nombre || `Cliente ${audit.clientId}`).toLowerCase();
                  return filtroNombre === '' || clienteNombre.includes(filtroNombre.toLowerCase());
                });
                
                auditoriasFiltradas.forEach(audit => {
                  const clienteId = audit.clientId;
                  const clienteNombre = audit.client?.nombre || `Cliente ${clienteId}`;
                  if (!empresas[clienteId]) {
                    empresas[clienteId] = { 
                      nombre: clienteNombre, 
                      auditorias: [],
                      total: 0 
                    };
                  }
                  
                  let monto = parseFloat(audit.costoFinal || 100);
                  if (audit.prioridad === 'prioritaria') monto *= 1.5;
                  if (audit.prioridad === 'urgente') monto *= 2;
                  
                  empresas[clienteId].auditorias.push(audit);
                  empresas[clienteId].total += monto;
                });

                return (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '30px' }}>
                    {Object.entries(empresas).map(([clienteId, empresa]) => (
                      <div key={clienteId} style={{
                        border: '2px solid #e5e7eb',
                        borderRadius: '12px',
                        overflow: 'hidden'
                      }}>
                        {/* HEADER DE LA EMPRESA */}
                        <div style={{
                          background: '#f3f4f6',
                          padding: '15px 20px',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          borderBottom: '1px solid #e5e7eb'
                        }}>
                          <div>
                            <h4 style={{ margin: '0 0 5px 0', fontSize: '1.25rem', fontWeight: 'bold' }}>
                              🏢 {empresa.nombre}
                            </h4>
                            <p style={{ margin: 0, color: '#6b7280' }}>
                              {empresa.auditorias.length} auditorías • Total: {formatMoney(empresa.total)}
                            </p>
                          </div>
                          <button
                            onClick={() => cobrarPaqueteEmpresa(parseInt(clienteId), empresa.nombre)}
                            style={{
                              padding: '12px 24px',
                              backgroundColor: '#10b981',
                              color: 'white',
                              border: 'none',
                              borderRadius: '8px',
                              cursor: 'pointer',
                              fontWeight: 'bold',
                              fontSize: '14px'
                            }}
                          >
                            💰 COBRAR PAQUETE COMPLETO
                          </button>
                        </div>

                        {/* TABLA DE AUDITORÍAS DE LA EMPRESA */}
                        <div style={{ overflowX: 'auto' }}>
                          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                              <tr style={{ background: '#f9fafb' }}>
                                <th style={{ padding: '12px', width: '40px', textAlign: 'center', borderBottom: '1px solid #e5e7eb' }}>
                                  <input
                                    type="checkbox"
                                    checked={empresa.auditorias.length > 0 && empresa.auditorias.every((a: any) => selectedPorCliente[parseInt(clienteId)]?.has(a.id))}
                                    onChange={() => {
                                      const cId = parseInt(clienteId);
                                      const allIds = empresa.auditorias.map((a: any) => a.id);
                                      const allSelected = allIds.every((id: number) => selectedPorCliente[cId]?.has(id));
                                      setSelectedPorCliente(prev => {
                                        const current = new Set(prev[cId] || []);
                                        if (allSelected) {
                                          allIds.forEach((id: number) => current.delete(id));
                                        } else {
                                          allIds.forEach((id: number) => current.add(id));
                                        }
                                        return { ...prev, [cId]: current };
                                      });
                                    }}
                                    title="Seleccionar todas"
                                  />
                                </th>
                                <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #e5e7eb' }}>Auditoría</th>
                                <th style={{ padding: '12px', textAlign: 'center', borderBottom: '1px solid #e5e7eb' }}>Prioridad</th>
                                <th style={{ padding: '12px', textAlign: 'right', borderBottom: '1px solid #e5e7eb' }}>Valor Base</th>
                                <th style={{ padding: '12px', textAlign: 'right', borderBottom: '1px solid #e5e7eb' }}>Multiplicador</th>
                                <th style={{ padding: '12px', textAlign: 'right', borderBottom: '1px solid #e5e7eb' }}>Total a Cobrar</th>
                                <th style={{ padding: '12px', textAlign: 'center', borderBottom: '1px solid #e5e7eb' }}>Acciones</th>
                              </tr>
                            </thead>
                            <tbody>
                              {empresa.auditorias.map((audit: any) => {
                                const valorBase = parseFloat(audit.costoFinal || 100);
                                let multiplicador = 1;
                                let total = valorBase;
                                
                                if (audit.prioridad === 'prioritaria') {
                                  multiplicador = 1.5;
                                  total = valorBase * 1.5;
                                } else if (audit.prioridad === 'urgente') {
                                  multiplicador = 2;
                                  total = valorBase * 2;
                                }
                                
                                return (
                                  <tr key={audit.id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                                    <td style={{ padding: '12px', textAlign: 'center' }}>
                                      <input
                                        type="checkbox"
                                        checked={selectedPorCliente[parseInt(clienteId)]?.has(audit.id) || false}
                                        onChange={() => toggleAuditoria(parseInt(clienteId), audit.id)}
                                      />
                                    </td>
                                    <td style={{ padding: '12px' }}>{audit.titulo && audit.titulo.trim() !== '' && audit.titulo !== `Auditoría #${audit.id}` ? audit.titulo : `Auditoría #${audit.id}`}</td>
                                    <td style={{ padding: '12px', textAlign: 'center' }}>
                                      <span style={{
                                        padding: '4px 8px',
                                        borderRadius: '4px',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        background: audit.prioridad === 'urgente' ? '#fef2f2' : 
                                                  audit.prioridad === 'prioritaria' ? '#fef3c7' : '#f0fdf4',
                                        color: audit.prioridad === 'urgente' ? '#dc2626' : 
                                              audit.prioridad === 'prioritaria' ? '#ca8a04' : '#166534'
                                      }}>
                                        {audit.prioridad?.toUpperCase() || 'NORMAL'}
                                      </span>
                                    </td>
                                    <td style={{ padding: '12px', textAlign: 'right' }}>{formatMoney(valorBase)}</td>
                                    <td style={{ padding: '12px', textAlign: 'right' }}>x{multiplicador}</td>
                                    <td style={{ padding: '12px', textAlign: 'right', fontWeight: 'bold', color: '#166534' }}>
                                      {formatMoney(total)}
                                    </td>
                                    <td style={{ padding: '12px', textAlign: 'center' }}>
                                      <div style={{ display: 'flex', gap: '4px', justifyContent: 'center', flexWrap: 'wrap' }}>
                                        <button
                                          onClick={() => cobrarConPrioridad(audit.id)}
                                          style={{
                                            padding: '4px 6px',
                                            backgroundColor: '#eab308',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '3px',
                                            cursor: 'pointer',
                                            fontSize: '10px'
                                          }}
                                          title="Cobrar con prioridad (precio duplicado)"
                                        >
                                          💰
                                        </button>
                                        <button
                                          onClick={() => cobrarNormal(audit.id)}
                                          style={{
                                            padding: '4px 6px',
                                            backgroundColor: '#6b7280',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '3px',
                                            cursor: 'pointer',
                                            fontSize: '10px'
                                          }}
                                          title="Cobrar normal"
                                        >
                                          💵
                                        </button>
                                        <button
                                          onClick={() => marcarGratis(audit.id)}
                                          style={{
                                            padding: '4px 6px',
                                            backgroundColor: '#ef4444',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '3px',
                                            cursor: 'pointer',
                                            fontSize: '10px'
                                          }}
                                          title="Gratis"
                                        >
                                          🆓
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>

                        {/* Barra de seleccionadas */}
                        {(() => {
                          const cId = parseInt(clienteId);
                          const info = getInfoSeleccion(cId);
                          if (info.count === 0) return null;
                          return (
                            <div style={{
                              padding: '12px 20px',
                              background: '#eff6ff',
                              borderTop: '2px solid #3b82f6',
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center'
                            }}>
                              <span style={{ color: '#1e40af', fontWeight: 'bold' }}>
                                {info.count} seleccionada(s) - {formatMoney(info.total)}
                              </span>
                              <button
                                onClick={() => cobrarSeleccionadas(cId, empresa.nombre)}
                                style={{
                                  padding: '8px 16px',
                                  backgroundColor: '#3b82f6',
                                  color: 'white',
                                  border: 'none',
                                  borderRadius: '6px',
                                  cursor: 'pointer',
                                  fontWeight: 'bold',
                                  fontSize: '13px'
                                }}
                              >
                                COBRAR SELECCIONADAS
                              </button>
                            </div>
                          );
                        })()}
                      </div>
                    ))}
                  </div>
                );
              })()
            )}
          </div>

          {/* Auditorías Cobradas - Agrupadas por Cliente y Sucursal */}
          {ingresos.auditoriasCobradasMes.length > 0 && (
            <div style={{ marginTop: '30px' }}>
              <h3 style={{
                marginBottom: '15px',
                padding: '10px',
                background: '#d4edda',
                borderRadius: '6px',
                color: '#155724'
              }}>
                ✅ Auditorías Cobradas ({ingresos.auditoriasCobradasMes.length})
              </h3>

              {(() => {
                // Agrupar por cliente y sucursal
                const clientesMap = {};

                ingresos.auditoriasCobradasMes.forEach((audit: any) => {
                  const clienteId = audit.clientId || 'sin-cliente';
                  const clienteNombre = audit.clientId ? (audit.client?.nombre || `Cliente ${audit.clientId}`) : '💵 Ingresos Generales (sin cliente)';
                  const branchId = audit.branchId || 'sin-sucursal';
                  const branchNombre = audit.branchId ? (audit.branch?.nombre || 'Sucursal Principal') : 'Ingreso General';

                  if (!clientesMap[clienteId]) {
                    clientesMap[clienteId] = {
                      nombre: clienteNombre,
                      sucursales: {},
                      total: 0,
                      esIngresoGeneral: !audit.clientId
                    };
                  }

                  if (!clientesMap[clienteId].sucursales[branchId]) {
                    clientesMap[clienteId].sucursales[branchId] = {
                      nombre: branchNombre,
                      auditorias: [],
                      total: 0
                    };
                  }

                  const monto = parseFloat(audit.costoFinal || audit.precioTotal || 0);
                  clientesMap[clienteId].sucursales[branchId].auditorias.push(audit);
                  clientesMap[clienteId].sucursales[branchId].total += monto;
                  clientesMap[clienteId].total += monto;
                });

                return (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '30px' }}>
                    {Object.entries(clientesMap).map(([clienteId, cliente]: [string, any]) => (
                      <div key={clienteId} style={{
                        border: cliente.esIngresoGeneral ? '2px solid #fbbf24' : '2px solid #86efac',
                        borderRadius: '12px',
                        overflow: 'hidden',
                        backgroundColor: cliente.esIngresoGeneral ? '#fffbeb' : '#f0fdf4'
                      }}>
                        {/* Header del Cliente */}
                        <div style={{
                          background: cliente.esIngresoGeneral ? '#fef3c7' : '#dcfce7',
                          padding: '15px 20px',
                          borderBottom: cliente.esIngresoGeneral ? '2px solid #fbbf24' : '2px solid #86efac'
                        }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div>
                              <h4 style={{ margin: '0 0 5px 0', fontSize: '1.25rem', fontWeight: 'bold', color: cliente.esIngresoGeneral ? '#92400e' : '#166534' }}>
                                {cliente.esIngresoGeneral ? '💵' : '🏢'} {cliente.nombre}
                              </h4>
                              <p style={{ margin: 0, color: cliente.esIngresoGeneral ? '#b45309' : '#15803d', fontWeight: '500' }}>
                                Total {cliente.esIngresoGeneral ? 'Ingresos Generales' : 'Cliente'}: {formatMoney(cliente.total)}
                              </p>
                            </div>
                            {!cliente.esIngresoGeneral && (
                              <button
                                onClick={() => {
                                  setMostrarFormIngresoManual(mostrarFormIngresoManual === parseInt(clienteId) ? null : parseInt(clienteId));
                                  setIngresoManual({
                                    clienteId: clienteId,
                                    titulo: '',
                                    monto: '',
                                    fecha: new Date().toISOString().split('T')[0]
                                  });
                                }}
                                style={{
                                  padding: '8px 16px',
                                  backgroundColor: '#10b981',
                                  color: 'white',
                                  border: 'none',
                                  borderRadius: '6px',
                                  cursor: 'pointer',
                                  fontWeight: '500',
                                  fontSize: '13px'
                                }}
                              >
                                ➕ Ingreso Manual
                              </button>
                            )}
                          </div>

                          {/* Formulario de Ingreso Manual */}
                          {mostrarFormIngresoManual === parseInt(clienteId) && (
                            <div style={{
                              marginTop: '15px',
                              padding: '15px',
                              backgroundColor: 'white',
                              borderRadius: '8px',
                              border: '2px solid #86efac'
                            }}>
                              <h5 style={{ margin: '0 0 12px 0', color: '#166534' }}>
                                Registrar Ingreso Manual para {cliente.nombre}
                              </h5>
                              <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: '10px', marginBottom: '12px' }}>
                                <input
                                  type="text"
                                  placeholder="Título (ej: Pedido del día 30/09 por video - Sucursal Centro)"
                                  value={ingresoManual.titulo}
                                  onChange={(e) => setIngresoManual({...ingresoManual, titulo: e.target.value})}
                                  style={{
                                    padding: '10px',
                                    border: '1px solid #d1d5db',
                                    borderRadius: '6px',
                                    fontSize: '13px'
                                  }}
                                />
                                <input
                                  type="number"
                                  placeholder="Monto ($)"
                                  value={ingresoManual.monto}
                                  onChange={(e) => setIngresoManual({...ingresoManual, monto: e.target.value})}
                                  style={{
                                    padding: '10px',
                                    border: '1px solid #d1d5db',
                                    borderRadius: '6px',
                                    fontSize: '13px'
                                  }}
                                />
                                <input
                                  type="date"
                                  value={ingresoManual.fecha}
                                  onChange={(e) => setIngresoManual({...ingresoManual, fecha: e.target.value})}
                                  style={{
                                    padding: '10px',
                                    border: '1px solid #d1d5db',
                                    borderRadius: '6px',
                                    fontSize: '13px'
                                  }}
                                />
                              </div>
                              <div style={{ display: 'flex', gap: '8px' }}>
                                <button
                                  onClick={() => registrarIngresoManual(clienteId, cliente.nombre)}
                                  style={{
                                    padding: '8px 16px',
                                    backgroundColor: '#10b981',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    fontSize: '13px',
                                    fontWeight: '500'
                                  }}
                                >
                                  ✓ Registrar
                                </button>
                                <button
                                  onClick={() => {
                                    setMostrarFormIngresoManual(null);
                                    setIngresoManual({
                                      clienteId: '',
                                      titulo: '',
                                      monto: '',
                                      fecha: new Date().toISOString().split('T')[0]
                                    });
                                  }}
                                  style={{
                                    padding: '8px 16px',
                                    backgroundColor: '#6b7280',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    fontSize: '13px'
                                  }}
                                >
                                  Cancelar
                                </button>
                              </div>
                            </div>
                          )}
                        </div>

                        {/* Sucursales */}
                        {Object.entries(cliente.sucursales).map(([branchId, sucursal]: [string, any]) => (
                          <div key={branchId} style={{
                            margin: '15px',
                            border: '1px solid #bbf7d0',
                            borderRadius: '8px',
                            overflow: 'hidden',
                            backgroundColor: 'white'
                          }}>
                            {/* Header de Sucursal */}
                            <div style={{
                              background: '#f0fdf4',
                              padding: '12px 15px',
                              borderBottom: '1px solid #bbf7d0',
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center'
                            }}>
                              <div>
                                <span style={{ fontWeight: 'bold', color: '#166534', fontSize: '1rem' }}>
                                  📍 {sucursal.nombre}
                                </span>
                                <span style={{ marginLeft: '15px', color: '#6b7280', fontSize: '0.875rem' }}>
                                  {sucursal.auditorias.length} auditorías
                                </span>
                              </div>
                              <span style={{ fontWeight: 'bold', color: '#166534', fontSize: '1.125rem' }}>
                                {formatMoney(sucursal.total)}
                              </span>
                            </div>

                            {/* Tabla de Auditorías */}
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                              <thead>
                                <tr style={{ background: '#f9fafb' }}>
                                  <th style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid #e5e7eb', fontSize: '0.875rem' }}>Auditoría</th>
                                  <th style={{ padding: '10px', textAlign: 'center', borderBottom: '1px solid #e5e7eb', fontSize: '0.875rem' }}>Fecha Entrega</th>
                                  <th style={{ padding: '10px', textAlign: 'center', borderBottom: '1px solid #e5e7eb', fontSize: '0.875rem' }}>Fecha Pago</th>
                                  <th style={{ padding: '10px', textAlign: 'right', borderBottom: '1px solid #e5e7eb', fontSize: '0.875rem' }}>Monto</th>
                                  <th style={{ padding: '10px', textAlign: 'center', borderBottom: '1px solid #e5e7eb', fontSize: '0.875rem' }}>Acciones</th>
                                </tr>
                              </thead>
                              <tbody>
                                {sucursal.auditorias.map((audit: any) => {
                                  const fechaEntrega = audit.fechaEntrega
                                    ? new Date(audit.fechaEntrega).toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' })
                                    : audit.updatedAt
                                    ? new Date(audit.updatedAt).toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' })
                                    : '-';

                                  const fechaPago = audit.fechaPago
                                    ? new Date(audit.fechaPago).toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' })
                                    : audit.updatedAt
                                    ? new Date(audit.updatedAt).toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' })
                                    : '-';

                                  return (
                                    <tr key={audit.id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                                      <td style={{ padding: '10px', fontSize: '0.875rem' }}>
                                        {audit.titulo && audit.titulo.trim() !== '' && audit.titulo !== `Auditoría #${audit.id}`
                                          ? audit.titulo
                                          : `Auditoría #${audit.id}`}
                                      </td>
                                      <td style={{ padding: '10px', textAlign: 'center', fontSize: '0.875rem', color: '#6b7280' }}>
                                        📅 {fechaEntrega}
                                      </td>
                                      <td style={{ padding: '10px', textAlign: 'center', fontSize: '0.875rem', color: '#6b7280' }}>
                                        💰 {fechaPago}
                                      </td>
                                      <td style={{ padding: '10px', textAlign: 'right', fontWeight: 'bold', color: '#166534', fontSize: '0.875rem' }}>
                                        {formatMoney(parseFloat(audit.costoFinal || audit.precioTotal || 0))}
                                      </td>
                                      <td style={{ padding: '10px', textAlign: 'center' }}>
                                        <button
                                          onClick={() => revertirCobro(audit.id)}
                                          style={{
                                            padding: '4px 8px',
                                            backgroundColor: '#dc2626',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            fontSize: '11px'
                                          }}
                                          title="Revertir cobro"
                                        >
                                          ↩️ Revertir
                                        </button>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        ))}
                      </div>
                    ))}

                    {/* Total General */}
                    <div style={{
                      background: '#dcfce7',
                      border: '3px solid #86efac',
                      borderRadius: '12px',
                      padding: '20px',
                      textAlign: 'center'
                    }}>
                      <div style={{ fontSize: '1.125rem', color: '#166534', fontWeight: '500', marginBottom: '5px' }}>
                        TOTAL COBRADO ESTE MES
                      </div>
                      <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#166534' }}>
                        {formatMoney(ingresos.totalCobradoMes)}
                      </div>
                    </div>
                  </div>
                );
              })()}
            </div>
          )}
        </div>
      )}

      {/* TAB EGRESOS */}
      {activeTab === 'egresos' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h2>💸 Detalle de Egresos - {meses[mes - 1]} {anio}</h2>
            
            {/* Control para alternar período de sueldos */}
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <span style={{ fontSize: '14px', color: '#6b7280' }}>Sueldos de:</span>
              <button
                onClick={() => setMostrarSueldosMesActual(!mostrarSueldosMesActual)}
                style={{
                  padding: '8px 16px',
                  backgroundColor: mostrarSueldosMesActual ? '#10b981' : '#6366f1',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '12px',
                  fontWeight: '500'
                }}
              >
                {mostrarSueldosMesActual ?
                  `💰 Sueldos ${meses[mes - 1]}` :
                  `💰 Sueldos ${meses[egresos.mesParaSueldos - 1]}`
                }
              </button>
            </div>
          </div>
          
          {/* Total Gastos - Prominente arriba */}
          <div style={{
            marginBottom: '30px',
            textAlign: 'center'
          }}>
            <div style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: '#ef4444',
              backgroundColor: '#fef2f2',
              padding: '20px 30px',
              borderRadius: '12px',
              border: '3px solid #fecaca',
              display: 'inline-block',
              boxShadow: '0 4px 6px -1px rgba(239, 68, 68, 0.1)'
            }}>
              💸 Total Gastos: ${(egresos.totalGastos + egresos.totalSueldosPagados).toLocaleString()}
            </div>
          </div>
          
          {/* Botón para agregar gasto */}
          <div style={{ marginBottom: '20px' }}>
            <button
              onClick={() => setMostrarFormGasto(!mostrarFormGasto)}
              style={{
                padding: '12px 24px',
                backgroundColor: '#ef4444',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500'
              }}
            >
              ➕ Registrar Nuevo Gasto
            </button>
          </div>

          {/* Formulario de nuevo gasto */}
          {mostrarFormGasto && (
            <div style={{
              marginBottom: '30px',
              padding: '20px',
              backgroundColor: '#fff',
              border: '2px solid #ef4444',
              borderRadius: '8px',
              position: 'relative',
              zIndex: 10
            }}>
              <h4 style={{ marginBottom: '15px' }}>Registrar Gasto Operativo</h4>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                <input
                  type="text"
                  placeholder="Descripción del gasto"
                  value={nuevoGasto.descripcion}
                  onChange={(e) => setNuevoGasto({...nuevoGasto, descripcion: e.target.value})}
                  style={{
                    padding: '12px',
                    border: '2px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '14px',
                    outline: 'none',
                    cursor: 'text',
                    userSelect: 'text',
                    pointerEvents: 'auto'
                  }}
                />
                <input
                  type="number"
                  placeholder="Monto ($)"
                  value={nuevoGasto.monto}
                  onChange={(e) => setNuevoGasto({...nuevoGasto, monto: e.target.value})}
                  style={{
                    padding: '12px',
                    border: '2px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '14px',
                    outline: 'none',
                    cursor: 'text',
                    userSelect: 'text',
                    pointerEvents: 'auto'
                  }}
                />
                <select
                  value={nuevoGasto.categoria}
                  onChange={(e) => setNuevoGasto({...nuevoGasto, categoria: e.target.value})}
                  style={{
                    padding: '12px',
                    border: '2px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '14px',
                    outline: 'none',
                    cursor: 'pointer',
                    pointerEvents: 'auto'
                  }}
                >
                  <option value="operativo">Operativo</option>
                  <option value="administrativo">Administrativo</option>
                  <option value="impuestos">Impuestos</option>
                  <option value="servicios">Servicios</option>
                  <option value="otros">Otros</option>
                </select>
                <input
                  type="date"
                  value={nuevoGasto.fecha}
                  onChange={(e) => setNuevoGasto({...nuevoGasto, fecha: e.target.value})}
                  style={{
                    padding: '12px',
                    border: '2px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '14px',
                    outline: 'none',
                    cursor: 'text',
                    pointerEvents: 'auto'
                  }}
                />
              </div>
              
              {/* Campo explicación obligatorio para contable */}
              {user?.role === 'contable' && (
                <div style={{ marginTop: '15px' }}>
                  <textarea
                    placeholder="Explicación obligatoria (mínimo 15 caracteres): ¿Por qué es necesario este gasto?"
                    value={nuevoGasto.explicacion}
                    onChange={(e) => setNuevoGasto({...nuevoGasto, explicacion: e.target.value})}
                    style={{
                      width: '100%',
                      padding: '12px',
                      border: '2px solid #ef4444',
                      borderRadius: '6px',
                      fontSize: '14px',
                      outline: 'none',
                      minHeight: '80px',
                      resize: 'vertical',
                      backgroundColor: '#fef2f2'
                    }}
                  />
                  {nuevoGasto.explicacion.length < 15 && (
                    <div style={{ color: '#ef4444', fontSize: '12px', marginTop: '5px' }}>
                      ⚠️ Explicación obligatoria para contables (mínimo 15 caracteres)
                    </div>
                  )}
                </div>
              )}
              
              <div style={{ marginTop: '15px', display: 'flex', gap: '10px' }}>
                <button
                  onClick={registrarGasto}
                  style={{
                    padding: '10px 20px',
                    backgroundColor: '#10b981',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }}
                >
                  ✓ Guardar Gasto
                </button>
                <button
                  onClick={crearGastosExistentes}
                  style={{
                    padding: '10px 20px',
                    backgroundColor: '#f59e0b',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }}
                >
                  ⚙️ Crear Gastos de Sueldos Pagados
                </button>
                <button
                  onClick={() => {
                    setMostrarFormGasto(false);
                    setNuevoGasto({ descripcion: '', monto: '', categoria: 'operativo', fecha: new Date().toISOString().split('T')[0], explicacion: '' });
                  }}
                  style={{
                    padding: '10px 20px',
                    backgroundColor: '#6b7280',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }}
                >
                  Cancelar
                </button>
              </div>
            </div>
          )}

          {/* Sueldos Pendientes */}
          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ 
              marginBottom: '15px', 
              padding: '10px',
              background: '#fef3c7',
              borderRadius: '6px',
              color: '#92400e'
            }}>
              💰 Sueldos por Pagar - {meses[egresos.mesParaSueldos - 1]} {egresos.anioParaSueldos} ({egresos.sueldosPendientes.length})
            </h3>
            
            {egresos.sueldosPendientes.length === 0 ? (
              <p style={{ color: '#6b7280', textAlign: 'center', padding: '20px' }}>
                No hay sueldos pendientes
              </p>
            ) : (
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ background: '#f3f4f6' }}>
                      <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e5e7eb' }}>Operador</th>
                      <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #e5e7eb' }}>Período</th>
                      <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #e5e7eb' }}>Tipo Pago</th>
                      <th style={{ padding: '12px', textAlign: 'right', borderBottom: '2px solid #e5e7eb' }}>Monto</th>
                      <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #e5e7eb' }}>Estado</th>
                      <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #e5e7eb' }}>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {egresos.sueldosPendientes.map((sueldo: any) => (
                      <tr key={sueldo.id} style={{ borderBottom: '1px solid #e5e7eb' }}>
                        <td style={{ padding: '12px' }}>{sueldo.operador?.name || `Operador ${sueldo.operadorId}`}</td>
                        <td style={{ padding: '12px', textAlign: 'center' }}>{sueldo.mes}/{sueldo.anio}</td>
                        <td style={{ padding: '12px', textAlign: 'center' }}>
                          <span style={{
                            padding: '4px 8px',
                            borderRadius: '4px',
                            fontSize: '12px',
                            background: '#e0e7ff',
                            color: '#3730a3'
                          }}>
                            {sueldo.tipoPago || 'OBJETIVOS'}
                          </span>
                        </td>
                        <td style={{ padding: '12px', textAlign: 'right', fontWeight: 'bold' }}>
                          {formatMoney(parseFloat(sueldo.sueldoFinal || 0))}
                        </td>
                        <td style={{ padding: '12px', textAlign: 'center' }}>
                          <span style={{
                            padding: '4px 8px',
                            borderRadius: '4px',
                            fontSize: '12px',
                            fontWeight: 'bold',
                            background: '#fef3c7',
                            color: '#92400e'
                          }}>
                            PENDIENTE
                          </span>
                        </td>
                        <td style={{ padding: '12px', textAlign: 'center' }}>
                          <button
                            onClick={() => pagarSueldo(sueldo)}
                            style={{
                              padding: '6px 12px',
                              backgroundColor: '#3b82f6',
                              color: 'white',
                              border: 'none',
                              borderRadius: '4px',
                              cursor: 'pointer',
                              fontSize: '12px'
                            }}
                          >
                            💰 Pagar
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr style={{ background: '#f9fafb', fontWeight: 'bold' }}>
                      <td colSpan={3} style={{ padding: '12px', textAlign: 'right' }}>TOTAL PENDIENTE:</td>
                      <td colSpan={2} style={{ padding: '12px', textAlign: 'right', fontSize: '1.125rem', color: '#dc2626' }}>
                        {formatMoney(egresos.totalSueldosPendientes)}
                      </td>
                      <td></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            )}
          </div>

          {/* Sueldos Pagados (con opción de revertir) */}
          {egresos.sueldosPagados.length > 0 && (
            <div style={{ marginBottom: '30px' }}>
              <h3 style={{ 
                marginBottom: '15px', 
                padding: '10px',
                background: '#d4edda',
                borderRadius: '6px',
                color: '#155724'
              }}>
                ✅ Sueldos Pagados ({egresos.sueldosPagados.length})
              </h3>
              
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ background: '#f3f4f6' }}>
                      <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e5e7eb' }}>Operador</th>
                      <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #e5e7eb' }}>Período</th>
                      <th style={{ padding: '12px', textAlign: 'right', borderBottom: '2px solid #e5e7eb' }}>Monto</th>
                      <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #e5e7eb' }}>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {egresos.sueldosPagados.map((sueldo: any) => (
                      <tr key={sueldo.id} style={{ borderBottom: '1px solid #e5e7eb' }}>
                        <td style={{ padding: '12px' }}>{sueldo.operador?.name || `Operador ${sueldo.operadorId}`}</td>
                        <td style={{ padding: '12px', textAlign: 'center' }}>{sueldo.mes}/{sueldo.anio}</td>
                        <td style={{ padding: '12px', textAlign: 'right', fontWeight: 'bold' }}>
                          {formatMoney(parseFloat(sueldo.sueldoFinal || 0))}
                        </td>
                        <td style={{ padding: '12px', textAlign: 'center' }}>
                          <button
                            onClick={() => revertirPagoSueldo(sueldo)}
                            style={{
                              padding: '6px 12px',
                              backgroundColor: '#dc2626',
                              color: 'white',
                              border: 'none',
                              borderRadius: '4px',
                              cursor: 'pointer',
                              fontSize: '12px'
                            }}
                            title="Revertir pago - El sueldo volverá a estado pendiente"
                          >
                            ↩️ Revertir
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Adelantos */}
          {egresos.adelantos.length > 0 && (
            <div>
              <h3 style={{ 
                marginBottom: '15px', 
                padding: '10px',
                background: '#fef3c7',
                borderRadius: '6px',
                color: '#92400e'
              }}>
                💰 Adelantos ({egresos.adelantos.length})
              </h3>
              
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ background: '#f3f4f6' }}>
                      <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e5e7eb' }}>Empleado</th>
                      <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #e5e7eb' }}>Fecha</th>
                      <th style={{ padding: '12px', textAlign: 'right', borderBottom: '2px solid #e5e7eb' }}>Monto</th>
                      <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e5e7eb' }}>Concepto</th>
                      <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #e5e7eb' }}>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {egresos.adelantos.map((adelanto, index) => (
                      <tr key={index} style={{ borderBottom: '1px solid #e5e7eb' }}>
                        <td style={{ padding: '12px' }}>
                          {adelanto.usuario?.nombre || `Usuario ${adelanto.usuarioId}`}
                        </td>
                        <td style={{ padding: '12px', textAlign: 'center' }}>
                          {new Date(adelanto.fecha).toLocaleDateString('es-ES')}
                        </td>
                        <td style={{ padding: '12px', textAlign: 'right', fontWeight: 'bold', color: '#dc2626' }}>
                          -{formatMoney(parseFloat(adelanto.monto || 0))}
                        </td>
                        <td style={{ padding: '12px' }}>
                          {adelanto.concepto || 'Adelanto de sueldo'}
                        </td>
                        <td style={{ padding: '12px', textAlign: 'center' }}>
                          <button
                            onClick={() => {
                              if (confirm('¿Seguro que deseas revertir este adelanto?')) {
                                // TODO: Implementar revertir adelanto
                              }
                            }}
                            style={{
                              padding: '6px 12px',
                              backgroundColor: '#dc2626',
                              color: 'white',
                              border: 'none',
                              borderRadius: '4px',
                              cursor: 'pointer',
                              fontSize: '12px'
                            }}
                            title="Revertir adelanto"
                          >
                            ↩️ Revertir
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}


          {/* Gastos Operativos */}
          {egresos.gastos.length > 0 && (
            <div>
              <h3 style={{ 
                marginBottom: '15px', 
                padding: '10px',
                background: '#fee2e2',
                borderRadius: '6px',
                color: '#991b1b'
              }}>
                🏢 Gastos Operativos ({egresos.gastos.length})
              </h3>
              
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ background: '#f3f4f6' }}>
                      <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e5e7eb' }}>Descripción</th>
                      <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #e5e7eb' }}>Categoría</th>
                      <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #e5e7eb' }}>Fecha</th>
                      <th style={{ padding: '12px', textAlign: 'right', borderBottom: '2px solid #e5e7eb' }}>Monto</th>
                      <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #e5e7eb' }}>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {egresos.gastos.map((gasto: any) => (
                      <tr key={gasto.id} style={{ borderBottom: '1px solid #e5e7eb' }}>
                        <td style={{ padding: '12px' }}>{gasto.descripcion}</td>
                        <td style={{ padding: '12px', textAlign: 'center' }}>{gasto.categoria}</td>
                        <td style={{ padding: '12px', textAlign: 'center' }}>
                          {new Date(gasto.fecha).toLocaleDateString()}
                        </td>
                        <td style={{ padding: '12px', textAlign: 'right', fontWeight: 'bold' }}>
                          {formatMoney(parseFloat(gasto.monto || 0))}
                        </td>
                        <td style={{ padding: '12px', textAlign: 'center' }}>
                          <button
                            onClick={() => revertirGasto(gasto.id, gasto.descripcion)}
                            style={{
                              padding: '6px 12px',
                              backgroundColor: '#dc2626',
                              color: 'white',
                              border: 'none',
                              borderRadius: '4px',
                              fontSize: '12px',
                              cursor: 'pointer',
                              fontWeight: '500'
                            }}
                            onMouseOver={(e) => e.target.style.backgroundColor = '#b91c1c'}
                            onMouseOut={(e) => e.target.style.backgroundColor = '#dc2626'}
                          >
                            🔄 Revertir
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr style={{ background: '#f9fafb', fontWeight: 'bold' }}>
                      <td colSpan={4} style={{ padding: '12px', textAlign: 'right' }}>TOTAL GASTOS:</td>
                      <td style={{ padding: '12px', textAlign: 'right', fontSize: '1.125rem', color: '#dc2626' }}>
                        {formatMoney(egresos.totalGastos)}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          )}

        </div>
      )}

      {/* TAB PERSONAL */}
      {activeTab === 'personal' && (
        <div>
          <h2 style={{ marginBottom: '30px' }}>👥 Gestión de Personal - Adelantos y Plus</h2>
          
          
          {/* Formulario simple para adelantos y plus */}
          <div style={{
            backgroundColor: '#f9fafb',
            borderRadius: '12px',
            padding: '25px',
            border: '1px solid #e5e7eb'
          }}>
            <h3 style={{ marginBottom: '20px', color: '#374151' }}>Registrar Adelanto o Plus</h3>
            
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '20px' }}>
              <select 
                value={selectedEmpleado}
                onChange={(e) => setSelectedEmpleado(e.target.value)}
                style={{
                  padding: '12px',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '14px'
                }}>
                <option value="">Seleccionar empleado...</option>
                {usuarios.map(user => (
                  <option key={user.id} value={user.id}>
                    {user.name} ({user.role})
                  </option>
                ))}
              </select>
              
              <select style={{
                padding: '12px',
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                fontSize: '14px'
              }}>
                <option value="adelanto">Adelanto</option>
                <option value="plus">Plus</option>
              </select>
            </div>
            
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '15px', marginBottom: '20px' }}>
              <input
                type="number"
                placeholder="Monto"
                value={montoAdelanto}
                onChange={(e) => setMontoAdelanto(e.target.value)}
                style={{
                  padding: '12px',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '14px'
                }}
              />
              
              <input
                type="text"
                placeholder="Concepto (ej: adelanto de palabra del 10/09)"
                value={conceptoAdelanto}
                onChange={(e) => setConceptoAdelanto(e.target.value)}
                style={{
                  padding: '12px',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '14px'
                }}
              />
            </div>
            
            <button 
              onClick={() => {
                if (!selectedEmpleado || !montoAdelanto || !conceptoAdelanto) {
                  alert('Complete todos los campos');
                  return;
                }
                const empleado = usuarios.find(u => u.id == selectedEmpleado);
                if (confirm(`¿Registrar pago de $${montoAdelanto} para ${empleado?.name}?`)) {
                  alert('✅ Funcionalidad pendiente de implementación en backend');
                  setSelectedEmpleado('');
                  setMontoAdelanto('');
                  setConceptoAdelanto('');
                }
              }}
              style={{
                padding: '12px 24px',
                backgroundColor: selectedEmpleado && montoAdelanto && conceptoAdelanto ? '#10b981' : '#9ca3af',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: selectedEmpleado && montoAdelanto && conceptoAdelanto ? 'pointer' : 'not-allowed',
                fontWeight: '500'
              }}>
              Registrar Pago
            </button>
          </div>
          
          <div style={{ marginTop: '30px' }}>
            <h3 style={{ marginBottom: '15px' }}>Historial de Pagos Especiales</h3>
            <div style={{
              backgroundColor: '#f9fafb',
              padding: '20px',
              borderRadius: '8px',
              textAlign: 'center',
              color: '#6b7280'
            }}>
              No hay pagos especiales registrados
            </div>
          </div>
        </div>
      )}

      {/* TAB BALANCE */}
      {activeTab === 'balance' && (
        <div>
          <h2 style={{ marginBottom: '30px' }}>⚖️ Balance y Proyecciones - {meses[mes - 1]} {anio}</h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '30px',
            marginBottom: '30px'
          }}>
            {/* Saldo Real Total (Acumulado) */}
            <div style={{
              background: balance.saldoRealTotal >= 0 ? '#f0fdf4' : '#fef2f2',
              border: `2px solid ${balance.saldoRealTotal >= 0 ? '#86efac' : '#fca5a5'}`,
              borderRadius: '12px',
              padding: '25px',
              textAlign: 'center'
            }}>
              <h3 style={{ marginBottom: '10px', color: '#374151' }}>💰 Saldo Real Total</h3>
              <p style={{ fontSize: '2.5rem', fontWeight: 'bold', color: getColorForBalance(balance.saldoRealTotal), margin: 0 }}>
                {formatMoney(balance.saldoRealTotal)}
              </p>
              <p style={{ color: '#6b7280', marginTop: '10px', fontSize: '0.875rem' }}>
                (Acumulado histórico)
              </p>
            </div>

            {/* Proyección */}
            <div style={{
              background: balance.proyeccion >= 0 ? '#f0fdf4' : '#fef2f2',
              border: `2px solid ${balance.proyeccion >= 0 ? '#86efac' : '#fca5a5'}`,
              borderRadius: '12px',
              padding: '25px',
              textAlign: 'center'
            }}>
              <h3 style={{ marginBottom: '10px', color: '#374151' }}>📈 Proyección Completa</h3>
              <p style={{ fontSize: '2.5rem', fontWeight: 'bold', color: getColorForBalance(balance.proyeccion), margin: 0 }}>
                {formatMoney(balance.proyeccion)}
              </p>
              <p style={{ color: '#6b7280', marginTop: '10px', fontSize: '0.875rem' }}>
                (Incluye pendientes de cobro y pago)
              </p>
            </div>
          </div>

          {/* Desglose detallado del mes actual */}
          <div style={{
            background: '#f9fafb',
            borderRadius: '12px',
            padding: '25px',
            marginBottom: '30px'
          }}>
            <h3 style={{ marginBottom: '20px' }}>📊 Movimiento del Mes Actual</h3>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px', background: '#e0e7ff', borderRadius: '6px' }}>
                <span style={{ fontWeight: '500' }}>💵 Saldo Mes Anterior</span>
                <span style={{ fontWeight: 'bold', color: '#4338ca' }}>
                  {formatMoney(balance.saldoMesAnterior)}
                </span>
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px', background: '#f0fdf4', borderRadius: '6px' }}>
                <span style={{ fontWeight: '500' }}>➕ Ingresos del Mes</span>
                <span style={{ fontWeight: 'bold', color: '#166534' }}>
                  {formatMoney(balance.ingresosMes)}
                </span>
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px', background: '#fef2f2', borderRadius: '6px' }}>
                <span style={{ fontWeight: '500' }}>➖ Egresos del Mes</span>
                <span style={{ fontWeight: 'bold', color: '#991b1b' }}>
                  {formatMoney(balance.egresosMes)}
                </span>
              </div>

              <hr style={{ border: 'none', borderTop: '2px solid #e5e7eb' }} />

              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px', background: '#fef3c7', borderRadius: '6px' }}>
                <span style={{ fontWeight: '600', fontSize: '1.125rem' }}>📈 Movimiento del Mes</span>
                <span style={{
                  fontWeight: 'bold',
                  fontSize: '1.25rem',
                  color: getColorForBalance(balance.movimientoMes)
                }}>
                  {formatMoney(balance.movimientoMes)}
                </span>
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px', background: '#dbeafe', borderRadius: '6px' }}>
                <span style={{ fontWeight: '600', fontSize: '1.125rem' }}>💰 Saldo Real Total</span>
                <span style={{
                  fontWeight: 'bold',
                  fontSize: '1.25rem',
                  color: getColorForBalance(balance.saldoRealTotal)
                }}>
                  {formatMoney(balance.saldoRealTotal)}
                </span>
              </div>
            </div>
          </div>

          {/* Desglose completo de proyecciones */}
          <div style={{
            background: '#f9fafb',
            borderRadius: '12px',
            padding: '25px'
          }}>
            <h3 style={{ marginBottom: '20px' }}>📊 Proyección Completa</h3>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px', background: '#f0fdf4', borderRadius: '6px' }}>
                <span style={{ fontWeight: '500' }}>➕ Total Ingresos (Cobrados + Por Cobrar)</span>
                <span style={{ fontWeight: 'bold', color: '#166534' }}>
                  {formatMoney(ingresos.totalCobradoMes + ingresos.totalPorCobrar)}
                </span>
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px', background: '#fef2f2', borderRadius: '6px' }}>
                <span style={{ fontWeight: '500' }}>➖ Total Egresos (Solo Pagados)</span>
                <span style={{ fontWeight: 'bold', color: '#991b1b' }}>
                  {formatMoney(egresos.totalSueldosPagados + egresos.totalGastos)}
                </span>
              </div>

              <hr style={{ border: 'none', borderTop: '2px solid #e5e7eb' }} />

              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px', background: '#f0f9ff', borderRadius: '6px' }}>
                <span style={{ fontWeight: '600', fontSize: '1.125rem' }}>🎯 Resultado Final Proyectado</span>
                <span style={{
                  fontWeight: 'bold',
                  fontSize: '1.25rem',
                  color: getColorForBalance(
                    ingresos.totalCobradoMes -
                    (egresos.totalSueldosPagados + egresos.totalGastos)
                  )
                }}>
                  {formatMoney(
                    ingresos.totalCobradoMes -
                    (egresos.totalSueldosPagados + egresos.totalGastos)
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* TAB ATRASO CLIENTES */}
      {activeTab === 'atraso-clientes' && (
        <div className="atraso-clientes-container">
          {/* Estilos para impresión */}
          <style>{`
            @media print {
              body * {
                visibility: hidden;
              }
              .atraso-clientes-container, .atraso-clientes-container * {
                visibility: visible;
              }
              .atraso-clientes-container {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
              }
              .no-print, .no-print-input {
                display: none !important;
              }
              .print-only {
                display: inline !important;
              }
              table {
                font-size: 11px;
              }
              th, td {
                padding: 6px 8px !important;
              }
              textarea {
                display: none !important;
              }
              input[type="checkbox"] {
                display: none !important;
              }
              h2 {
                font-size: 16px !important;
                margin-bottom: 10px !important;
              }
              p {
                display: none !important;
              }
            }
          `}</style>
          <h2 style={{ marginBottom: '20px' }}>⏰ Listado de Clientes por Atraso de Auditoría</h2>
          <p style={{ color: '#6b7280', marginBottom: '20px' }}>
            Clientes ordenados desde el más atrasado (más días sin auditoría) hasta el que más pide.
            Hacé clic en un cliente para ver el detalle de cada sucursal.
          </p>

          {/* Filtros */}
          <div style={{
            display: 'flex',
            gap: '15px',
            marginBottom: '20px',
            flexWrap: 'wrap',
            alignItems: 'flex-end'
          }}>
            <div>
              <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#374151' }}>
                Buscar cliente
              </label>
              <input
                type="text"
                placeholder="Nombre, email, CUIT..."
                value={filtroAtraso}
                onChange={(e) => setFiltroAtraso(e.target.value)}
                style={{
                  padding: '10px 15px',
                  border: '1px solid #d1d5db',
                  borderRadius: '8px',
                  width: '250px'
                }}
              />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#374151' }}>
                Mínimo días sin auditoría
              </label>
              <input
                type="number"
                placeholder="Ej: 30"
                value={minDiasAtraso}
                onChange={(e) => setMinDiasAtraso(e.target.value)}
                style={{
                  padding: '10px 15px',
                  border: '1px solid #d1d5db',
                  borderRadius: '8px',
                  width: '120px'
                }}
              />
            </div>
            <button
              onClick={cargarAtrasosClientes}
              disabled={loadingAtrasos}
              style={{
                padding: '10px 20px',
                background: '#3b82f6',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: loadingAtrasos ? 'not-allowed' : 'pointer',
                fontWeight: '500'
              }}
            >
              {loadingAtrasos ? 'Cargando...' : '🔍 Buscar'}
            </button>
            <button
              onClick={imprimirListadoAtrasos}
              className="no-print"
              disabled={atrasosClientes.length === 0}
              style={{
                padding: '10px 15px',
                background: atrasosClientes.length > 0 ? '#8b5cf6' : '#d1d5db',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: atrasosClientes.length > 0 ? 'pointer' : 'not-allowed',
                fontWeight: '500'
              }}
            >
              🖨️ Imprimir
            </button>
            {atrasosClientes.length > 0 && (
              <>
                <button
                  onClick={expandirTodosClientes}
                  style={{
                    padding: '10px 15px',
                    background: '#10b981',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontWeight: '500'
                  }}
                >
                  Expandir Todos
                </button>
                <button
                  onClick={colapsarTodosClientes}
                  style={{
                    padding: '10px 15px',
                    background: '#6b7280',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontWeight: '500'
                  }}
                >
                  Colapsar Todos
                </button>
              </>
            )}
          </div>

          {/* Tabla de resultados */}
          {loadingAtrasos ? (
            <div style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>
              Cargando datos...
            </div>
          ) : atrasosClientes.length === 0 ? (
            <div style={{
              textAlign: 'center',
              padding: '40px',
              background: '#f9fafb',
              borderRadius: '12px',
              color: '#6b7280'
            }}>
              <p>Hacé clic en "Buscar" para cargar el listado de clientes.</p>
            </div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ background: '#f3f4f6' }}>
                    <th style={{ padding: '12px 15px', textAlign: 'left', borderBottom: '2px solid #e5e7eb', fontWeight: '600', width: '30px' }}></th>
                    <th style={{ padding: '12px 15px', textAlign: 'left', borderBottom: '2px solid #e5e7eb', fontWeight: '600' }}>Cliente / Sucursal</th>
                    <th style={{ padding: '12px 15px', textAlign: 'left', borderBottom: '2px solid #e5e7eb', fontWeight: '600' }}>Contacto / Dirección</th>
                    <th style={{ padding: '12px 15px', textAlign: 'center', borderBottom: '2px solid #e5e7eb', fontWeight: '600' }}>Sucursales</th>
                    <th style={{ padding: '12px 15px', textAlign: 'center', borderBottom: '2px solid #e5e7eb', fontWeight: '600' }}>Auditorías</th>
                    <th style={{ padding: '12px 15px', textAlign: 'center', borderBottom: '2px solid #e5e7eb', fontWeight: '600' }}>Última Auditoría</th>
                    <th style={{ padding: '12px 15px', textAlign: 'center', borderBottom: '2px solid #e5e7eb', fontWeight: '600' }}>Días sin Auditoría</th>
                    <th style={{ padding: '12px 15px', textAlign: 'left', borderBottom: '2px solid #e5e7eb', fontWeight: '600', minWidth: '200px' }}>Nota</th>
                    <th style={{ padding: '12px 15px', textAlign: 'center', borderBottom: '2px solid #e5e7eb', fontWeight: '600' }}>Verificado</th>
                  </tr>
                </thead>
                <tbody>
                  {atrasosClientes.map((cliente: any, index: number) => {
                    const colorAtraso = getColorAtraso(cliente.diasSinAuditoria);
                    const estaExpandido = clientesExpandidos.has(cliente.id);
                    const tieneSucursales = cliente.sucursales && cliente.sucursales.length > 0;

                    return (
                      <React.Fragment key={cliente.id}>
                        {/* Fila del cliente */}
                        <tr
                          onClick={() => tieneSucursales && toggleClienteExpandido(cliente.id)}
                          style={{
                            background: index % 2 === 0 ? 'white' : '#f9fafb',
                            borderBottom: '1px solid #e5e7eb',
                            cursor: tieneSucursales ? 'pointer' : 'default'
                          }}
                        >
                          <td style={{ padding: '12px 10px', textAlign: 'center' }}>
                            {tieneSucursales && (
                              <span style={{ fontSize: '16px', color: '#6b7280' }}>
                                {estaExpandido ? '▼' : '▶'}
                              </span>
                            )}
                          </td>
                          <td style={{ padding: '12px 15px' }}>
                            <div style={{ fontWeight: '600', color: '#111827', display: 'flex', alignItems: 'center', gap: '8px' }}>
                              {cliente.nombre}
                              {cliente.tieneAuditoriasFijas && (
                                <span
                                  title={cliente.faltanAuditoriasFijas
                                    ? `⚠️ Faltan ${cliente.auditoriasFaltantes} de 4 auditorías este mes (tiene ${cliente.auditoriasMesActual})`
                                    : `✅ Cumple 4 auditorías mensuales (${cliente.auditoriasMesActual}/4)`
                                  }
                                  style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '4px',
                                    padding: '2px 8px',
                                    borderRadius: '12px',
                                    fontSize: '11px',
                                    fontWeight: '600',
                                    background: cliente.faltanAuditoriasFijas ? '#fef2f2' : '#f0fdf4',
                                    color: cliente.faltanAuditoriasFijas ? '#dc2626' : '#16a34a',
                                    border: cliente.faltanAuditoriasFijas ? '1px solid #fecaca' : '1px solid #bbf7d0'
                                  }}
                                >
                                  {cliente.faltanAuditoriasFijas ? '⚠️' : '✅'} {cliente.auditoriasMesActual}/4
                                </span>
                              )}
                            </div>
                            {cliente.cuit && <div style={{ fontSize: '12px', color: '#6b7280' }}>CUIT: {cliente.cuit}</div>}
                            {cliente.tieneAuditoriasFijas && cliente.faltanAuditoriasFijas && (
                              <div style={{
                                fontSize: '11px',
                                color: '#dc2626',
                                marginTop: '4px',
                                fontWeight: '500'
                              }}>
                                ⚠️ Faltan {cliente.auditoriasFaltantes} auditorías este mes
                              </div>
                            )}
                          </td>
                          <td style={{ padding: '12px 15px' }}>
                            <div style={{ fontSize: '14px' }}>{cliente.email || '-'}</div>
                            <div style={{ fontSize: '12px', color: '#6b7280' }}>{cliente.telefono || ''}</div>
                            {cliente.contactoPrincipal && (
                              <div style={{ fontSize: '12px', color: '#6b7280' }}>{cliente.contactoPrincipal}</div>
                            )}
                          </td>
                          <td style={{ padding: '12px 15px', textAlign: 'center' }}>
                            <span style={{
                              background: '#e0e7ff',
                              color: '#3730a3',
                              padding: '4px 10px',
                              borderRadius: '12px',
                              fontSize: '13px',
                              fontWeight: '500'
                            }}>
                              {cliente.totalSucursales}
                            </span>
                          </td>
                          <td style={{ padding: '12px 15px', textAlign: 'center' }}>
                            <span style={{
                              background: '#d1fae5',
                              color: '#065f46',
                              padding: '4px 10px',
                              borderRadius: '12px',
                              fontSize: '13px',
                              fontWeight: '500'
                            }}>
                              {cliente.totalAuditoriasCompletadas}
                            </span>
                          </td>
                          <td style={{ padding: '12px 15px', textAlign: 'center', fontSize: '14px' }}>
                            {cliente.fechaUltimaAuditoria
                              ? new Date(cliente.fechaUltimaAuditoria).toLocaleDateString('es-AR')
                              : <span style={{ color: '#ef4444', fontStyle: 'italic' }}>Nunca</span>
                            }
                          </td>
                          <td style={{ padding: '12px 15px', textAlign: 'center' }}>
                            <span style={{
                              background: colorAtraso + '20',
                              color: colorAtraso,
                              padding: '6px 12px',
                              borderRadius: '20px',
                              fontSize: '14px',
                              fontWeight: '700'
                            }}>
                              {cliente.diasSinAuditoria === null
                                ? '∞'
                                : `${cliente.diasSinAuditoria} días`
                              }
                            </span>
                          </td>
                          {/* Celda de Nota */}
                          <td style={{ padding: '12px 15px' }} onClick={(e) => e.stopPropagation()}>
                            <textarea
                              className="no-print-input"
                              value={cliente.notaAtraso || ''}
                              onChange={(e) => {
                                const newVal = e.target.value;
                                setAtrasosClientes(prev => prev.map((c: any) =>
                                  c.id === cliente.id ? { ...c, notaAtraso: newVal } : c
                                ));
                              }}
                              onBlur={(e) => actualizarNotaCliente(cliente.id, e.target.value)}
                              placeholder="Agregar nota..."
                              style={{
                                width: '100%',
                                minWidth: '180px',
                                padding: '8px',
                                border: '1px solid #d1d5db',
                                borderRadius: '6px',
                                fontSize: '13px',
                                resize: 'vertical',
                                minHeight: '40px'
                              }}
                            />
                            {/* Mostrar nota en impresión */}
                            <span className="print-only" style={{ display: 'none', fontSize: '12px' }}>
                              {cliente.notaAtraso || '-'}
                            </span>
                          </td>
                          {/* Celda de Verificado */}
                          <td style={{ padding: '12px 15px', textAlign: 'center' }} onClick={(e) => e.stopPropagation()}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
                              <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
                                <input
                                  type="checkbox"
                                  checked={cliente.verificadoAtraso || false}
                                  onChange={(e) => toggleVerificacionCliente(cliente.id, e.target.checked)}
                                  style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                                />
                                <span className="no-print" style={{ fontSize: '12px', color: '#6b7280' }}>
                                  {cliente.verificadoAtraso ? 'Sí' : 'No'}
                                </span>
                              </label>
                              {cliente.verificadoAtraso && (
                                <div style={{ fontSize: '11px', color: '#059669', textAlign: 'center' }}>
                                  <div>{cliente.verificadoPorNombre}</div>
                                  <div>{cliente.fechaVerificacionAtraso ? new Date(cliente.fechaVerificacionAtraso).toLocaleDateString('es-AR') : ''}</div>
                                </div>
                              )}
                            </div>
                          </td>
                        </tr>

                        {/* Filas de sucursales (expandidas) */}
                        {estaExpandido && cliente.sucursales && cliente.sucursales.map((sucursal: any) => {
                          const colorSucursal = getColorAtraso(sucursal.diasSinAuditoria);
                          return (
                            <tr
                              key={`suc-${sucursal.id}`}
                              style={{
                                background: '#fefce8',
                                borderBottom: '1px solid #fef08a'
                              }}
                            >
                              <td style={{ padding: '8px 10px' }}></td>
                              <td style={{ padding: '8px 15px', paddingLeft: '40px' }}>
                                <div style={{ fontSize: '14px', color: '#713f12', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                  ↳ {sucursal.nombre}
                                  {cliente.tieneAuditoriasFijas && (
                                    <span style={{
                                      fontSize: '10px',
                                      padding: '1px 6px',
                                      borderRadius: '8px',
                                      background: sucursal.auditoriasMesActual > 0 ? '#d1fae5' : '#fee2e2',
                                      color: sucursal.auditoriasMesActual > 0 ? '#065f46' : '#991b1b'
                                    }}>
                                      {sucursal.auditoriasMesActual} este mes
                                    </span>
                                  )}
                                </div>
                              </td>
                              <td style={{ padding: '8px 15px' }}>
                                <div style={{ fontSize: '13px', color: '#92400e' }}>
                                  {sucursal.direccion || '-'}
                                </div>
                              </td>
                              <td style={{ padding: '8px 15px', textAlign: 'center' }}>
                                -
                              </td>
                              <td style={{ padding: '8px 15px', textAlign: 'center' }}>
                                <span style={{
                                  background: sucursal.totalAuditorias > 0 ? '#d1fae5' : '#fee2e2',
                                  color: sucursal.totalAuditorias > 0 ? '#065f46' : '#991b1b',
                                  padding: '3px 8px',
                                  borderRadius: '10px',
                                  fontSize: '12px',
                                  fontWeight: '500'
                                }}>
                                  {sucursal.totalAuditorias}
                                </span>
                              </td>
                              <td style={{ padding: '8px 15px', textAlign: 'center', fontSize: '13px' }}>
                                {sucursal.fechaUltimaAuditoria
                                  ? new Date(sucursal.fechaUltimaAuditoria).toLocaleDateString('es-AR')
                                  : <span style={{ color: '#ef4444', fontStyle: 'italic' }}>Nunca</span>
                                }
                              </td>
                              <td style={{ padding: '8px 15px', textAlign: 'center' }}>
                                <span style={{
                                  background: colorSucursal + '20',
                                  color: colorSucursal,
                                  padding: '4px 10px',
                                  borderRadius: '15px',
                                  fontSize: '13px',
                                  fontWeight: '600'
                                }}>
                                  {sucursal.diasSinAuditoria === null
                                    ? '∞'
                                    : `${sucursal.diasSinAuditoria} días`
                                  }
                                </span>
                              </td>
                              {/* Celda de Nota para Sucursal */}
                              <td style={{ padding: '8px 15px' }}>
                                <textarea
                                  className="no-print-input"
                                  value={sucursal.notaAtraso || ''}
                                  onChange={(e) => {
                                    const newVal = e.target.value;
                                    setAtrasosClientes(prev => prev.map((c: any) => {
                                      if (c.id === cliente.id) {
                                        return {
                                          ...c,
                                          sucursales: c.sucursales.map((s: any) =>
                                            s.id === sucursal.id ? { ...s, notaAtraso: newVal } : s
                                          )
                                        };
                                      }
                                      return c;
                                    }));
                                  }}
                                  onBlur={(e) => actualizarNotaSucursal(cliente.id, sucursal.id, e.target.value)}
                                  placeholder="Nota sucursal..."
                                  style={{
                                    width: '100%',
                                    minWidth: '150px',
                                    padding: '6px',
                                    border: '1px solid #fef08a',
                                    borderRadius: '4px',
                                    fontSize: '12px',
                                    resize: 'vertical',
                                    minHeight: '32px',
                                    background: '#fffbeb'
                                  }}
                                />
                                <span className="print-only" style={{ display: 'none', fontSize: '11px' }}>
                                  {sucursal.notaAtraso || '-'}
                                </span>
                              </td>
                              {/* Celda de Verificado para Sucursal */}
                              <td style={{ padding: '8px 15px', textAlign: 'center' }}>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px' }}>
                                  <label style={{ display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer' }}>
                                    <input
                                      type="checkbox"
                                      checked={sucursal.verificadoAtraso || false}
                                      onChange={(e) => toggleVerificacionSucursal(cliente.id, sucursal.id, e.target.checked)}
                                      style={{ width: '16px', height: '16px', cursor: 'pointer' }}
                                    />
                                    <span className="no-print" style={{ fontSize: '11px', color: '#713f12' }}>
                                      {sucursal.verificadoAtraso ? 'Sí' : 'No'}
                                    </span>
                                  </label>
                                  {sucursal.verificadoAtraso && (
                                    <div style={{ fontSize: '10px', color: '#059669', textAlign: 'center' }}>
                                      <div>{sucursal.verificadoPorNombre}</div>
                                      <div>{sucursal.fechaVerificacionAtraso ? new Date(sucursal.fechaVerificacionAtraso).toLocaleDateString('es-AR') : ''}</div>
                                    </div>
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>

              {/* Resumen */}
              <div style={{
                marginTop: '20px',
                padding: '15px',
                background: '#f3f4f6',
                borderRadius: '8px',
                display: 'flex',
                gap: '30px',
                flexWrap: 'wrap'
              }}>
                <div>
                  <span style={{ color: '#6b7280' }}>Total clientes: </span>
                  <strong>{atrasosClientes.length}</strong>
                </div>
                <div>
                  <span style={{ color: '#6b7280' }}>Total sucursales: </span>
                  <strong>{atrasosClientes.reduce((sum: number, c: any) => sum + (c.sucursales?.length || 0), 0)}</strong>
                </div>
                <div>
                  <span style={{ color: '#6b7280' }}>Sucursales sin auditorías: </span>
                  <strong style={{ color: '#ef4444' }}>
                    {atrasosClientes.reduce((sum: number, c: any) =>
                      sum + (c.sucursales?.filter((s: any) => s.diasSinAuditoria === null).length || 0), 0)}
                  </strong>
                </div>
                <div>
                  <span style={{ color: '#6b7280' }}>Sucursales +90 días: </span>
                  <strong style={{ color: '#ef4444' }}>
                    {atrasosClientes.reduce((sum: number, c: any) =>
                      sum + (c.sucursales?.filter((s: any) => s.diasSinAuditoria !== null && s.diasSinAuditoria > 90).length || 0), 0)}
                  </strong>
                </div>
                <div>
                  <span style={{ color: '#6b7280' }}>Sucursales 60-90 días: </span>
                  <strong style={{ color: '#f59e0b' }}>
                    {atrasosClientes.reduce((sum: number, c: any) =>
                      sum + (c.sucursales?.filter((s: any) => s.diasSinAuditoria !== null && s.diasSinAuditoria > 60 && s.diasSinAuditoria <= 90).length || 0), 0)}
                  </strong>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* TAB COMISIONES EJECUTIVOS */}
      {activeTab === 'comisiones' && (
        <div>
          <h2 style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>💰 Comisiones de Ejecutivos</span>
          </h2>

          {/* Resumen de comisiones */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '20px',
            marginBottom: '30px'
          }}>
            <div style={{
              background: '#fef3c7',
              padding: '20px',
              borderRadius: '12px',
              border: '1px solid #fbbf24'
            }}>
              <div style={{ fontSize: '14px', color: '#92400e', marginBottom: '8px' }}>Pendientes de Pago</div>
              <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#b45309' }}>
                ${comisiones.resumen.totalPendiente?.toLocaleString() || 0}
              </div>
              <div style={{ fontSize: '12px', color: '#92400e' }}>
                {comisiones.resumen.cantidadPendientes} comisiones
              </div>
            </div>

            <div style={{
              background: '#d1fae5',
              padding: '20px',
              borderRadius: '12px',
              border: '1px solid #34d399'
            }}>
              <div style={{ fontSize: '14px', color: '#065f46', marginBottom: '8px' }}>Total Pagado</div>
              <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#059669' }}>
                ${comisiones.resumen.totalPagado?.toLocaleString() || 0}
              </div>
              <div style={{ fontSize: '12px', color: '#065f46' }}>
                {comisiones.resumen.cantidadPagadas} comisiones
              </div>
            </div>
          </div>

          {/* Filtros */}
          <div style={{
            display: 'flex',
            gap: '10px',
            marginBottom: '20px',
            alignItems: 'center'
          }}>
            <label style={{ fontSize: '14px', color: '#6b7280' }}>Filtrar por estado:</label>
            <select
              value={filtroComisionEstado}
              onChange={(e) => setFiltroComisionEstado(e.target.value as any)}
              style={{
                padding: '8px 16px',
                borderRadius: '8px',
                border: '1px solid #d1d5db',
                fontSize: '14px'
              }}
            >
              <option value="todos">Todos</option>
              <option value="pendiente">Pendientes</option>
              <option value="pagada">Pagadas</option>
            </select>
          </div>

          {/* Lista de comisiones */}
          {loadingComisiones ? (
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <div className="spinner" />
              <span style={{ marginLeft: '10px' }}>Cargando comisiones...</span>
            </div>
          ) : comisiones.lista.length === 0 ? (
            <div style={{
              textAlign: 'center',
              padding: '40px',
              background: '#f9fafb',
              borderRadius: '12px',
              color: '#6b7280'
            }}>
              <div style={{ fontSize: '48px', marginBottom: '10px' }}>💰</div>
              <div>No hay comisiones registradas</div>
            </div>
          ) : (
            <div>
              {/* Agrupar por ejecutivo */}
              {Object.entries(
                comisiones.lista.reduce((acc: any, com: any) => {
                  const ejecutivoId = com.ejecutivo_id;
                  const ejecutivoNombre = com.ejecutivo?.name || `Ejecutivo #${ejecutivoId}`;
                  if (!acc[ejecutivoId]) {
                    acc[ejecutivoId] = {
                      nombre: ejecutivoNombre,
                      email: com.ejecutivo?.email,
                      comisiones: [],
                      totalPendiente: 0,
                      totalPagado: 0
                    };
                  }
                  acc[ejecutivoId].comisiones.push(com);
                  if (com.estado === 'pendiente') {
                    acc[ejecutivoId].totalPendiente += parseFloat(com.monto_comision) || 0;
                  } else {
                    acc[ejecutivoId].totalPagado += parseFloat(com.monto_comision) || 0;
                  }
                  return acc;
                }, {})
              ).map(([ejecutivoId, data]: [string, any]) => (
                <div
                  key={ejecutivoId}
                  style={{
                    background: 'white',
                    border: '1px solid #e5e7eb',
                    borderRadius: '12px',
                    marginBottom: '20px',
                    overflow: 'hidden'
                  }}
                >
                  {/* Header del ejecutivo */}
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '16px 20px',
                    background: '#fed7aa',
                    borderBottom: '1px solid #fdba74'
                  }}>
                    <div>
                      <div style={{ fontWeight: '600', fontSize: '16px', color: '#c2410c' }}>
                        {data.nombre}
                      </div>
                      <div style={{ fontSize: '12px', color: '#ea580c' }}>{data.email}</div>
                    </div>
                    <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                      {data.totalPendiente > 0 && (
                        <div style={{
                          background: '#fef3c7',
                          padding: '8px 16px',
                          borderRadius: '8px',
                          fontSize: '14px',
                          fontWeight: '600',
                          color: '#b45309'
                        }}>
                          Pendiente: ${data.totalPendiente.toLocaleString()}
                        </div>
                      )}
                      {data.totalPendiente > 0 && (user.role === 'admin' || user.role === 'contable' || (user.role === 'ejecutivo' && parseInt(ejecutivoId) === user.id)) && (
                        <button
                          onClick={() => pagarComisionesMasivo(parseInt(ejecutivoId))}
                          style={{
                            background: '#059669',
                            color: 'white',
                            padding: '8px 16px',
                            borderRadius: '8px',
                            border: 'none',
                            cursor: 'pointer',
                            fontWeight: '600',
                            fontSize: '14px'
                          }}
                        >
                          Pagar Todo
                        </button>
                      )}
                    </div>
                  </div>

                  {/* Lista de comisiones del ejecutivo */}
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ background: '#f9fafb', fontSize: '13px', color: '#6b7280' }}>
                        <th style={{ padding: '12px 16px', textAlign: 'left' }}>Fecha</th>
                        <th style={{ padding: '12px 16px', textAlign: 'left' }}>Cliente</th>
                        <th style={{ padding: '12px 16px', textAlign: 'center' }}>Tipo</th>
                        <th style={{ padding: '12px 16px', textAlign: 'right' }}>Monto Base</th>
                        <th style={{ padding: '12px 16px', textAlign: 'right' }}>Comisión</th>
                        <th style={{ padding: '12px 16px', textAlign: 'center' }}>Estado</th>
                        {(user.role === 'admin' || user.role === 'contable' || user.role === 'ejecutivo') && (
                          <th style={{ padding: '12px 16px', textAlign: 'center' }}>Acción</th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {data.comisiones.map((com: any) => (
                        <tr
                          key={com.id}
                          style={{
                            borderBottom: '1px solid #e5e7eb',
                            background: com.estado === 'pagada' ? '#f0fdf4' : 'white'
                          }}
                        >
                          <td style={{ padding: '12px 16px', fontSize: '14px' }}>
                            {new Date(com.fecha_generada).toLocaleDateString()}
                          </td>
                          <td style={{ padding: '12px 16px', fontSize: '14px' }}>
                            {com.cliente?.nombre || '-'}
                          </td>
                          <td style={{ padding: '12px 16px', textAlign: 'center' }}>
                            <span style={{
                              padding: '4px 10px',
                              borderRadius: '12px',
                              fontSize: '12px',
                              fontWeight: '600',
                              background: com.tipo_comision === 'captacion' ? '#fef3c7' : '#dbeafe',
                              color: com.tipo_comision === 'captacion' ? '#b45309' : '#1e40af'
                            }}>
                              {com.tipo_comision === 'captacion' ? '🌟 Captación' : '💵 Cobro'}
                            </span>
                          </td>
                          <td style={{ padding: '12px 16px', textAlign: 'right', fontSize: '14px' }}>
                            ${parseFloat(com.monto_base || 0).toLocaleString()}
                          </td>
                          <td style={{ padding: '12px 16px', textAlign: 'right', fontSize: '14px', fontWeight: '600', color: '#059669' }}>
                            ${parseFloat(com.monto_comision || 0).toLocaleString()}
                          </td>
                          <td style={{ padding: '12px 16px', textAlign: 'center' }}>
                            <span style={{
                              padding: '4px 10px',
                              borderRadius: '12px',
                              fontSize: '12px',
                              fontWeight: '600',
                              background: com.estado === 'pagada' ? '#d1fae5' : '#fef3c7',
                              color: com.estado === 'pagada' ? '#065f46' : '#b45309'
                            }}>
                              {com.estado === 'pagada' ? '✓ Pagada' : '⏳ Pendiente'}
                            </span>
                          </td>
                          {(user.role === 'admin' || user.role === 'contable' || user.role === 'ejecutivo') && (
                            <td style={{ padding: '12px 16px', textAlign: 'center' }}>
                              {com.estado === 'pendiente' && (user.role !== 'ejecutivo' || com.ejecutivo_id === user.id) && (
                                <button
                                  onClick={() => pagarComision(com.id)}
                                  style={{
                                    background: '#10b981',
                                    color: 'white',
                                    padding: '6px 12px',
                                    borderRadius: '6px',
                                    border: 'none',
                                    cursor: 'pointer',
                                    fontSize: '12px'
                                  }}
                                >
                                  Pagar
                                </button>
                              )}
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* TAB CONFIGURACIÓN */}
      {activeTab === 'configuracion' && (
        <div>
          <h2 style={{ marginBottom: '30px' }}>⚙️ Configuración de Sueldos y Pagos</h2>
          
          {/* Usar el componente existente de configuración de sueldos */}
          <SueldosConfigTable
            user={user}
            onConfigUpdate={cargarDatos}
            selectedUserForEdit={null}
            onUserEditComplete={() => {}}
          />

        </div>
      )}

      {/* MODAL COBRO CON FACTURA */}
      {showModalCobro && cobroData && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999
        }}>
          <div style={{
            background: 'white',
            borderRadius: '12px',
            padding: '24px',
            maxWidth: '500px',
            width: '90%',
            boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
          }}>
            <h3 style={{ margin: '0 0 20px 0', color: '#1f2937' }}>
              💰 Registrar Cobro
            </h3>

            <div style={{ marginBottom: '16px', padding: '12px', background: '#f0fdf4', borderRadius: '8px', border: '1px solid #bbf7d0' }}>
              <strong style={{ color: '#166534' }}>{cobroData.clienteNombre}</strong>
              <br />
              <span style={{ color: '#6b7280', fontSize: '14px' }}>
                {['', 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'][cobroData.mes]} {cobroData.anio}
              </span>
              <br />
              <span style={{ fontSize: '18px', fontWeight: 'bold', color: '#166534' }}>
                Total: ${cobroData.totalPeriodo.toLocaleString('es-AR')}
              </span>
              <span style={{ marginLeft: '10px', color: '#6b7280', fontSize: '12px' }}>
                ({cobroData.auditorias.length} auditorías)
              </span>
            </div>

            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', marginBottom: '6px', fontWeight: 'bold', color: '#374151' }}>
                Detalle / Observaciones (opcional):
              </label>
              <textarea
                value={cobroDetalle}
                onChange={(e) => setCobroDetalle(e.target.value)}
                placeholder="Ej: Transferencia bancaria, efectivo, etc."
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '6px',
                  border: '1px solid #d1d5db',
                  resize: 'vertical',
                  minHeight: '60px',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '6px', fontWeight: 'bold', color: '#374151' }}>
                📎 Adjuntar Factura (opcional):
              </label>
              <input
                type="file"
                accept=".pdf,.jpg,.jpeg,.png"
                onChange={(e) => setCobroFactura(e.target.files?.[0] || null)}
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '6px',
                  border: '1px solid #d1d5db',
                  background: '#f9fafb',
                  boxSizing: 'border-box'
                }}
              />
              <small style={{ color: '#6b7280', fontSize: '12px' }}>
                Formatos aceptados: PDF, JPG, PNG. Se enviará por email al cliente.
              </small>
              {cobroFactura && (
                <div style={{ marginTop: '8px', padding: '8px', background: '#dbeafe', borderRadius: '4px', fontSize: '13px' }}>
                  📄 {cobroFactura.name}
                  <button
                    onClick={() => setCobroFactura(null)}
                    style={{ marginLeft: '10px', background: 'transparent', border: 'none', color: '#dc2626', cursor: 'pointer' }}
                  >
                    ✕ Quitar
                  </button>
                </div>
              )}
            </div>

            <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
              <button
                onClick={() => {
                  setShowModalCobro(false);
                  setCobroData(null);
                  setCobroDetalle('');
                  setCobroFactura(null);
                }}
                disabled={procesandoCobro}
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#6b7280',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: procesandoCobro ? 'not-allowed' : 'pointer',
                  fontWeight: 'bold'
                }}
              >
                Cancelar
              </button>
              <button
                onClick={cobrarPeriodo}
                disabled={procesandoCobro}
                style={{
                  padding: '10px 20px',
                  backgroundColor: procesandoCobro ? '#9ca3af' : '#10b981',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: procesandoCobro ? 'not-allowed' : 'pointer',
                  fontWeight: 'bold',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
              >
                {procesandoCobro ? (
                  <>
                    <span style={{
                      display: 'inline-block',
                      width: '16px',
                      height: '16px',
                      border: '2px solid white',
                      borderTopColor: 'transparent',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite'
                    }}></span>
                    Procesando...
                  </>
                ) : (
                  <>✅ Confirmar Cobro</>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FinanzasCompleto;